var _defineProperty = require("/home/ubuntu/workspace/bom-ui-preprod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _forecast, _evse, _pes, _liveVitalStats, _offline;

var mobile = {
  "nav": {
    "today": "Status",
    "history": "Energy",
    "layout": "Array",
    "menu": "Menu"
  },
  "poweredBy": "powered by",
  "button": {
    "cancel": "Cancel",
    "done": "Done",
    "login": "Sign in",
    "today": "Today",
    "submit": "Submit",
    "ok": "OK",
    "choose_file": "Choose File",
    "refresh": "Refresh",
    "send": "Send",
    "skip": "Skip",
    "continue": "Continue",
    "clickHere": "Click here",
    "confirm": "Confirm",
    "reset": "Reset",
    "edit": "Edit",
    "update": "Update",
    "next": "Next",
    "save": "Save",
    "no": "No",
    "yes": "Yes",
    "enable": "Enable",
    "setNow": "Set now",
    "gotIt": "Got it",
    "okGotIt": "Ok, Got it",
    "knowMore": "Know more",
    "noExportCredit": "I don't get Export Credit",
    "tryLater": "Try Later",
    "otherNetworks": "Other Networks"
  },
  "form": {
    "topic": "Topic",
    "contactSupport": {
      "success": {
        "message": "Thanks for contacting us.",
        "description": "We look forward to helping you resolve your issue. An Enphase expert will get in touch with you shortly.",
        "email_notify": "Report will be sent shortly to %{email}."
      },
      "error": {
        "message": "Failed to send message.",
        "description": "Please try again.",
        "reset_password": "Password expired. Kindly reset the password."
      }
    },
    "default": {
      "success": "Saved successfully",
      "error": "Please try again",
      "pleaseEnterAValue": "Please enter a value",
      "permissionDenied": "Permission Denied",
      "activeBatteryProfile": "You have an active Battery profile request. Please wait for confirmation or cancel that request to proceed."
    },
    "search": "Search"
  },
  "common": {
    "please": "Please",
    "contactSupport": "Contact Support",
    "forHelp": "for help.",
    "videos": "Videos",
    "articles": "Articles",
    "new": "New",
    "startDate": "Start Date",
    "endDate": "End Date",
    "clearedDate": "Cleared Date",
    "startTime": "Start Time",
    "endTime": "End Time",
    "duration": "Duration"
  },
  "errors": {
    "error": "Error",
    "errors": "Errors",
    "warning": "Warning",
    "email": "Please enter your email address",
    "password": "Please enter your password",
    "login": "The email and password you entered do not match our records.",
    "accInactive": "Account is inactive. Please contact your installer and try again once your system is fully active.",
    "expired": "Sorry, your login has expired.",
    "loggedout": "You have been logged out.",
    "report": "Sorry, an error occured.",
    "offline": "Please check your internet connection and try again.",
    "noInternet": "No Internet",
    "message": "Message",
    "tryagain": "Try again",
    "otherUnits": "Other Units",
    "retry": "Retry",
    "resetNow": "Reset Now",
    "resetPassword": "Your password is expired. Kindly reset it to view the report",
    "validEmail": "Please enter valid email address",
    "validPhone": "Please enter valid phone number",
    "fileError": "Company Logo must be between 0.05kb and 4MB.",
    "400": "Bad Request",
    "401": "Unauthorized Access",
    "403": "Forbidden Access",
    "404": "Resource Not Found",
    "422": "Unprocessable Entity",
    "500": "Internal Server Error.",
    "502": "Bad Gateway.",
    "503": "Service Unavailable.",
    "504": "Gateway Timeout.",
    "default": "Server error.",
    "400_text": "Bad Request",
    "401_text": "Unauthorized Access",
    "403_text": "Forbidden Access",
    "404_text": "Resource Not Found",
    "422_text": "Unprocessable Entity",
    "500_text": "Internal Server Error. Please try again later.",
    "502_text": "Bad Gateway. Please try again later.",
    "503_text": "Service Unavailable. Please try again later.",
    "504_text": "Gateway Timeout. Please try again later.",
    "default_text": "Server error. Please try again later.",
    "noDeviceFound": "No device found",
    "noBackupHistoryFound": "No backup history found",
    "noWiFiNetworkFound": "No Wi-Fi network found",
    "noResultFound": "No result found",
    "allSites": "All Sites",
    "favorites": "Favorites",
    "changesNotSaved": "Changes are not saved",
    "wantToExit": "Do you want to exit without saving?",
    "rateNotFound": "Rate not found"
  },
  "login": {
    "forgot": "Forgot password",
    "signup": "New account",
    "header": "Sign in to Enphase",
    "intro_content": "Enter your email address and password to sign in",
    "remember_me": "Remember me",
    "forgot_password": "Forgot your password?",
    "forgot_password_success": "If you have already registered with Enphase, please check your email for reset instructions.",
    "caps_lock_warning": "Caps Lock is on",
    "welcome_back": "Welcome back, %{user_name}. ",
    "en_us_installer_html": "Welcome %{user_name}. Visit our <a href='http://go.enphase.com/gettingstarted' target='_blank'>Getting Started site</a> to learn everything you need to know about designing, installing, and commissioning Enphase systems. ",
    "en_aunz_installer_html": "Welcome %{user_name}. Visit our <a href='http://go.enphase.com/au/gettingstarted' target='_blank'>Getting Started site</a> to learn everything you need to know about designing, installing, and commissioning Enphase systems. ",
    "provide_email_password": "Please provide a username and password.",
    "request_account": "Request an account",
    "subheader": {
      "new_user": "New to Enphase?",
      "enphasePES": "Enphase PES"
    },
    "new_user_content_html": "Enphase Energy products dramatically improve the performance of solar power systems. Using Enphase Microinverters, owners and operators increase the productivity and reliability of their solar installation.<br/><br/>To see Enphase in action, <a href='%{systems_list_link}'>take a look at our customers' installations.</a>",
    "public_system_content_html": "Want to see Enphase in action? <a href='%{systems_list_link}'>View public systems</a>",
    "register_new_user_html": "Installing your first Enphase system? <a href='%{register_user_link}'>Sign up for Enphase</a>",
    "recommended_browsers": "Enphase app is compatible with the following browsers: Chrome 5 or higher, Firefox 3.6 or higher, Internet Explorer 10 or higher, Microsoft Edge for Windows, Safari 4 or higher. Enphase app requires Adobe Flash Player 10.",
    "recommended_browsers_3x": "Enphase app is compatible with the following browsers: Chrome 44 or higher, Firefox 41 or higher, Internet Explorer 11, Microsoft Edge for Windows, Safari 8 or higher.",
    "cookies_required": "Cookies must be enabled.",
    "no_community": "This community is dedicated to technical discussions for Enphase installers. We welcome you to participate in discussions on our <a href='https://www.facebook.com/EnphaseEnergy'>Facebook page</a>.",
    "required": "You must sign in to access that page",
    "findInstaller": "Find an installer",
    "sizeYourSystem": "Design my system",
    "getEnphase": "Get Enphase",
    "experienceTheApp": "Experience app",
    "viewStorageSystem": "View storage system",
    "meetEnphase": "Meet Enphase",
    "enphaseSolar": "Enphase Solar",
    "enphaseStorage": "Enphase Storage"
  },
  "logout": {
    "confirm_logout": "You've been signed out. Thanks for visiting."
  },
  "password_recovery": {
    "activate_account": {
      "header": "Activate Account",
      "link": "Activate your account now"
    },
    "header": "Password Reset",
    "intro_content": "Enter your email ID registered with Enphase. We will send a link to reset your password to the email ID.",
    "login": "Sign In",
    "try_again": "Please try again.",
    "sent_message_html": "We have sent an email to %{email}. Click the link in the email to reset your password. <span style='color:red'>If you did not receive the email, please check your junk/spam folder.</span>",
    "invalid_request": "Invalid request",
    "invalid_link": "Unable to reset password. Password reset link is valid for 7 days. Please try again.",
    "success": "Successfully reset password.",
    "failed_password_reset": "Problem encountered. Please try again.",
    "password_requirements": "Your password must be at least six characters, must contain at least one number or special character, and can't be the same as your email address.",
    "note": "Password ",
    "OK": "OK",
    "sent_email": "We have sent an email to",
    "rest_pwd": "Click the link in the email to reset your password."
  },
  "users": {
    "new": "New User Registration",
    "company_details": "Company Details",
    "edit": "Edit User",
    "re-upload_documents": "Business ID re-upload",
    "site_accesses": "System Access",
    "login": "Sign in",
    "logged_in_as": "%{admin}, you are signed in as %{user}",
    "logout_as": "Stop",
    "reset_password": "Reset Password",
    "preview_marketing_description": "Preview only. Changes are not yet saved.",
    "preview_custom_welcome_message": "Preview only. Changes are not yet saved.",
    "reset_password_confirm_html": "<b>Are you sure you want to reset password for this user?</b><p>This will send a password reset email to the user.</p>",
    "reset_password_success": "An email to reset password will be sent to %{email}.",
    "reset_password_failed": "Failed to reset password.",
    "enlighten_manager_access": "This user has Enlighten Manager with module-level data access.",
    "myenlighten_access_note": "(only for users who are NOT associated with a company)",
    "module_level_access_note": "(with module-level data access)",
    "complimentary_note": "NOTE: Switching a user from MyEnlighten to Enlighten Manager constitutes giving away a software activation valued at %{price}. This transaction will be logged and reported to finance.",
    "purchase_note": "Software activation was purchased by %{email} for %{price} on %{date}.",
    "enlighten_version_title": "Enphase app Version",
    "unlock_account": "Unlock account",
    "enlighten_version": {
      "enlighten_manager": "Enlighten Manager",
      "my_enlighten": "MyEnlighten"
    },
    "self_installer_true": "I am a do-it-yourselfer installing Enphase products on my own home or business",
    "self_installer_false": "I am a solar professional registering on behalf of my company",
    "self_register_independent": "Other",
    "opt_in": "I agree to receive newsletters, promotions, and surveys regarding Enphase products or services.",
    "opt_in_info": "You can withdraw your consent at any time. For more information please see Enphase’s <a href='%{privacy_url}' target='_blank'>Privacy Policy</a>, or <a href='%{contact_url}' target='_blank'>contact us</a>.",
    "personal_details": "Personal Details",
    "enable_camera": "Enable access to camera for your app from the settings tab",
    "dont_allow": "Don't Allow",
    "cameraText": "This will allow you to select the image you would like to upload as your company logo"
  },
  "company": {
    "id": "Company ID",
    "active_users": "Active Users",
    "address1": "Street Address",
    "optional": "Optional",
    "address2": "Street Address 2",
    "address_id": "Location",
    "branch_name": "Branch Name",
    "branch_of": "Branch of",
    "city": "City",
    "companies": "Branches",
    "country": "Country",
    "duplicate_of": "Replaced with",
    "latitude": "Latitude",
    "logo_img": "Company Logo",
    "file_type_size": "Must be a JPEG or PNG file no larger than 4MB.",
    "file_recommendation": "For best results, we recommend a square image with a transparent background at least 400px wide by 400px tall.",
    "file_examples": "Example: C-46 license, GST Number",
    "logo_img_file_size": "Company Logo",
    "logo_img_content_type": "Company Logo",
    "longitude": "Longitude",
    "long_name": "Company Name",
    "marketing_description": "Company Description",
    "custom_welcome_message": "Customer Welcome Email Message",
    "show_logo_in_welcome_email": "Display company logo in customer welcome email",
    "name": "Name",
    "parent": "Parent Company",
    "phone": "Phone",
    "role": "Role",
    "roles": {
      "admin": "Support/Call Center",
      "installer": "Installer",
      "distributor": "Distributor",
      "third_party_owner": "Third Party Owner"
    },
    "state": "State/Province",
    "support_email": "Customer Support Email",
    "support_phone": "Customer Support Phone",
    "timezone": "Timezone",
    "url": "Website URL",
    "zip": "Zip/Postal Code",
    "is_installer": "This company installs Enphase systems",
    "errors": {
      "name_not_found": "Could not find company name"
    },
    "success": {
      "msg": "Your account has been created. Please check your email for instructions on how to sign in."
    }
  },
  "forecast": (_forecast = {
    "nodata": "Forecasted data is not available!",
    "nodata5": "We require atleast 5 days of production data to accurately forecast production data.",
    "nodata10": "We require at least 5 days of production data in the past 15 days to display your forecast.",
    "apifail": "Unable to display forecasted data!",
    "apifailSub": "Error in displaying forecasted data because of technical issues. Please check after sometime.",
    "weatherErr": "Error in displaying forecasted data because of unavailability of weather data.",
    "weatherProdErr": "Error in displaying forecasted data because of unavailability of production or weather data.",
    "genErr": "Error in displaying forecasted data because of technical issues.",
    "envoyErr1": "Production data is unavailable as your gateway is not reporting to the cloud.",
    "envoyErr2": "Production data is not updating as your gateway is not reporting to the cloud.",
    "microErr1": "Production data is unavailable because none of the microinverters are reporting.",
    "microErr2": "Production data is not updating because none of the microinverters are reporting.",
    "accCTA": "Why is your actual production different from the forecast?",
    "ctainfo": "Forecast is only a prediction to help you plan your energy needs. Please note that your production values might be different from the forecast.",
    "ctainfoRes": "Possible reasons for differences between actual production and forecast",
    "ctainfoRes1": "Frequent weather changes in your locality",
    "ctainfoRes2": "Some of your microinverters are not reporting",
    "ctainfoRes3": "Your system hasn’t reported for more than a day",
    "today": "Today",
    "forecast": "Forecast"
  }, _defineProperty(_forecast, "today", "Today"), _defineProperty(_forecast, "actual", "Actual"), _defineProperty(_forecast, "actualProd", "Actual Production"), _defineProperty(_forecast, "sunrise", "Sunrise"), _defineProperty(_forecast, "sunset", "Sunset"), _defineProperty(_forecast, "clearDay", "Mostly sunny"), _defineProperty(_forecast, "clearNight", "Mostly clear"), _defineProperty(_forecast, "rain", "Mostly rainy"), _defineProperty(_forecast, "snow", "Mostly snowy"), _defineProperty(_forecast, "sleet", "Mostly sleety"), _defineProperty(_forecast, "wind", "Mostly windy"), _defineProperty(_forecast, "fog", "Mostly foggy"), _defineProperty(_forecast, "cloudy", "Cloudy"), _defineProperty(_forecast, "partlycloudy", "Partly cloudy"), _defineProperty(_forecast, "unknown", "Unknown"), _defineProperty(_forecast, "timeFrom", "Showing 12:00 am"), _defineProperty(_forecast, "at12", "At 12:00 am"), _defineProperty(_forecast, "title", "Know your production forecast"), _defineProperty(_forecast, "infoIconPopup", "Production forecast is the prediction of how much energy your panels would produce today and for the next 5 days. The forecast is calculated based on your past energy production and weather forecast in your region."), _defineProperty(_forecast, "fiveday", "5-Day Forecast"), _defineProperty(_forecast, "tomo", "Tomorrow"), _forecast),
  "user": {
    "id": "User ID",
    "api_key": "API Key",
    "company": "Company",
    "company_id": "Company ID",
    "consumer": "MyEnlighten",
    "country": "Country",
    "email": "Email address",
    "email_confirm": "Confirm Email",
    "password": "Password",
    "first_name": "First Name",
    "last_name": "Last Name",
    "sfdc_email": "Email",
    "sfdc_subject": "Subject",
    "sfdc_message": "Message",
    "sfdc_siteId": "Enphase Site ID",
    "created_at": "Created At",
    "name": "Name",
    "updated_at": "Updated At",
    "status": "Status",
    "phone": "Phone",
    "locale": "Preferred Locale",
    "preferred_metric": "Units",
    "preferred_alert_level": "Default Alert Level",
    "preferred_array_builder": "Can Build Arrays",
    "preferred_show_dashboard_help": "Dashboard help preference",
    "preferred_new_look": "Preview Enlighten 3.0",
    "preferences": "Preferences",
    "role": "Role",
    "roles_mask": "Roles Mask",
    "sales_demo": "Sales Demo",
    "sees_modules": "Can See Module Data",
    "notes": "Notes",
    "prefers_monthly_email": "Subscribe to Monthly Email",
    "preferred_enphase_email": "Subscribe to Enphase Email",
    "prefers_privacy_policy_assent": "Accepted Privacy Policy terms",
    "active": "Active",
    "inactive": "Inactive",
    "add_user": "Add User",
    "self_installer": "Self Installer",
    "site_access_id": "Site ID",
    "user_access_id": "User ID",
    "with_company": "Include company details in my registration",
    "last_login": "Last Login",
    "acknowledge": "I acknowledge that I have read and agree to Enphase",
    "privacy_url": "Privacy Policy",
    "terms_url": "Terms of Service",
    "acknowledgementHead": "I have read Enphase’s",
    "acknowledgementBody": "and have read and agree to the"
  },
  "privacy_policy_broadcast": {
    "modal": {
      "title": "Our Privacy Policy has changed effective %{policy_date}",
      "acknowledgement": "I acknowledge that I have read and agree to Enphase’s <a href='%{privacy_url}' target='_blank'>Privacy Policy</a>.",
      "continue_button": "Continue",
      "privacy_settings_button": "Continue to Privacy Settings",
      "privacy_policy_agreement_required": "I acknowledge that I have read and agree to Enphase’s <a target='_blank' href='%{privacy_url}'>Privacy Policy</a>\nand <a target='_blank' href='%{terms_url}'>Terms of Service</a>.\n"
    }
  },
  "jquery_validate": {
    "messages": {
      "required": "This field is required."
    }
  },
  "validate": {
    "privacy_policy_accept": "If you do not agree to the terms of Enphase’s Privacy Policy and Terms of Service you may not register for Enphase app."
  },
  "period": {
    "hours": "Day",
    "days": "Month",
    "week": "Week",
    "months": "Year",
    "years": "Lifetime",
    "custom": "Custom"
  },
  "history": {
    "totals": "Totals",
    "graph": "Home",
    "production": "Produced",
    "consumption": "Consumed",
    "grid": "Utility",
    "export": "Exported",
    "import": "Imported",
    "netExported": "Net Exported",
    "netImported": "Net Imported",
    "battery": "Battery",
    "charge": "Charged",
    "discharge": "Discharged",
    "soc": "Battery",
    "hours": "",
    "months": "",
    "today": "Today",
    "battery_status": "Charge",
    "bulbs": "100w Bulb",
    "last_updated": "Updated",
    "power": "Power",
    "solar_produced": "Solar Produced",
    "solar_consumed": "Solar Consumed",
    "saved": "Saved",
    "emission_saved": "CO2 emission saved",
    "refrigerator": "Refrigerator",
    "produced_today": "Produced today",
    "produced_yesterday": "Produced yesterday",
    "this_week": "This week",
    "last_week": "Last week",
    "this_month": "This month",
    "last_month": "Last month",
    "this_year": "This year",
    "last_year": "Last year",
    "selected_day": "Selected Day",
    "previous_day": "Previous Day",
    "selected_week": "Selected Week",
    "previous_week": "Previous Week",
    "selected_month": "Selected Month",
    "previous_month": "Previous Month",
    "selected_year": "Selected Year",
    "previous_year": "Previous Year",
    "produced_this_week": "Produced this week",
    "produced_last_week": "Produced last week",
    "produced_this_year": "Produced this year",
    "produced_last_year": "Produced last year",
    "produced_this_month": "Produced this month",
    "produced_last_month": "Produced last month",
    "produced_lifetime": "Produced lifetime",
    "imported-exported": "Imported/Exported",
    "yesterday": {
      "hours": "Yesterday",
      "days": "Last Month",
      "months": "Last Year",
      "years": "Produced"
    },
    "lastyear": {
      "hours": "Last Year",
      "days": "Last Year",
      "months": "Last Year",
      "years": "Produced"
    },
    "generator": "Generator"
  },
  "custom_report": {
    "dataType": "Choose data type",
    "frequency": {
      "dataFrequency": "Choose data frequency",
      "daily": "daily",
      "weekly": "weekly",
      "monthly": "monthly",
      "yearly": "yearly",
      "generateReport": "We need atleast a week’s data to generate the report"
    }
  },
  "calendar": {
    "select": "Select a date",
    "scale": {
      "production": "Production",
      "consumption": "Consumption"
    },
    "weekDays": {
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "months": {
      "january": "January",
      "february": "February",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December",
      "jan": "Jan",
      "feb": "Feb",
      "mar": "Mar",
      "apr": "Apr",
      "jun": "Jun",
      "jul": "Jul",
      "aug": "Aug",
      "sep": "Sep",
      "oct": "Oct",
      "nov": "Nov",
      "dec": "Dec"
    },
    "time": {
      "hour": "hour",
      "hours": "hours",
      "minute": "minute",
      "minutes": "minutes",
      "second": "second",
      "seconds": "seconds",
      "millisecond": "millisecond",
      "milliseconds": "milliseconds",
      "day": "day",
      "h": "h",
      "hrs": "hrs",
      "min": "min",
      "mins": "mins"
    }
  },
  "status": {
    "nameChangeNormal": "Normal",
    "nameChangeError": 'Error',
    "nameChangeWarning": 'Warning',
    "system": "System",
    "activity": "By Activity",
    "manage": "Manage",
    "details": "Remotely Control Your Loads",
    "heading": "Monitor your loads",
    "dayTitle": "Today’s Status",
    "dayAltTitle": "Latest Status",
    "monthTitle": "This Month’s Status",
    "monthAltTitle": "Latest Monthly Status",
    "yearTitle": "This Year’s Status",
    "yearAltTitle": "Latest Yearly Status",
    "lifetimeTitle": "Lifetime Status",
    "lifetime": "Lifetime",
    "system_normal": "System Normal",
    "system_error": "System Error",
    "latest_power": "Latest Power",
    "peak_power": "Peak Power",
    "energyConsumed": "Energy Consumed",
    "energyProduced": "Energy Produced",
    "powerProduced": "Power Produced",
    "powerConsumed": "Power Consumed",
    "moreDetails": "More Details",
    "latest_power_text": "Latest Solar Power is the latest reported power output from your PV system",
    "peak_power_text": "Peak power is the maximum power output from your PV system for the chosen time period",
    "addEnphaseStorage": "Add Enphase Battery",
    "getAQuote": "Get a quote",
    "production": {
      "title": "Solar",
      "label": "Produced",
      "section": "Energy Destinations"
    },
    "consumption": {
      "title": "Usage",
      "label": "Consumed",
      "section": "Energy Sources"
    },
    "grid": {
      "title": "Net Energy",
      "export": "Exported",
      "import": "Imported",
      "label": "Net Energy with imported/exported",
      "section": "Energy Sources",
      "progressbarTitle": "Net energy from grid"
    },
    "breakdown": {
      "consumption": "Home",
      "battery": "Storage",
      "production": "Solar",
      "grid": "Utility",
      "export": "Exported",
      "import": "Imported",
      "soc": "Stored",
      "total": "Total",
      "peak": "Peak Power",
      "latest": "Latest Power",
      "next": "Next Report"
    },
    "battery": {
      "title": "Storage",
      "label": {
        "none": "Idle",
        "positive": "Charging",
        "negative": "Discharging"
      },
      "section": "Available Energy"
    },
    "charge": "Charge",
    "batteryCharge": "Battery Charge",
    "stormAlertOn": "Storm Alert: On",
    "batteryProfile": "Profile",
    "batteryInfo1": "Based on the last 24 hrs consumption (%{consumption}) your Enphase system will run for approximate ",
    "batteryInfo2": " without grid or solar power.",
    "batteryInfoWOSolar": " without grid.",
    "batteryErrorInfo": "We do not have enough data to estimate your battery backup time.",
    "to": "to",
    "batteryZeroErrorInfo": "You have zero hours of backup as your batteries are out of charge.",
    "hours": "hour(s)",
    "minutes": "minute(s)",
    "gridControls": {
      "verifyOtp": "Verify Code",
      "verificationCode": "Verification Code",
      "offGridContent": "You will lose connection to the Grid. The power available for consumption will be restricted.",
      "tryAgainContent": "Unable to establish a connection with the gateway.",
      "verifyOtpEmail": "Enter the 4-digit code that was sent to your registered email address.",
      "verifyOtpEmailMobile": "Enter the 4-digit code that was sent to your registered email address and the mobile number.",
      "verifyOtpUpdateMobile": "4-digit code will be sent to your registered email address.",
      "onGridContent": "Do you want to connect your system back to the Grid now?",
      "pleaseTryAgain": "please try again",
      "enterValidOtp": "Please enter a valid code",
      "didntReceiveOtp": "Didn't receive code?",
      "goOffGrid": "go Off Grid",
      "goOnGrid": "go On Grid",
      "tryAgain": "try again",
      "resend": "Resend",
      "alert": "The grid control access is disabled as an update for your system is in progress. This update may take up to 24 hours. Please wait for the update to complete.",
      "sendCode": "Send Code",
      "mobileStatus": "to receive code as text.",
      "myInfoButton": "Update your mobile number",
      "wpc1l1": "Your current consumption levels are higher than the available solar power production.  Please reduce your consumption to avoid system shutdown when transitioning.​",
      "wpc1l2": "You can view your current solar production and essential loads consumption in %{liveStatus}.",
      "wpc2l1": "Your average consumption over the past 15 minutes is greater than your average solar power production.  Please ensure that your current solar production is sufficient to support your consumption demands to avoid system shutdown when Off Grid.",
      "wpcOnGrid": "Your system is currently powered by generator. Switching to On Grid might lead to a temporary power disruption if your consumption is very high. Please reduce your consumption to avoid this disruption.",
      "wpcOnGrid2": "You can view your current consumption in %{liveStatus}."
    },
    "viewDetails": "View Details",
    "socMessageError1": "The aggregate storage",
    "socMessageError2": "excludes the storage percentages of",
    "socMessageError3": "Battery(s)",
    "socMessageThreshold": "Battery charge is unknown as none of the batteries reported data during last reporting cycle"
  },
  "menu": {
    "circuitDetails": "Circuit Details",
    "iqlccircuitDetails": "Circuit Details",
    "loadPanelView": "Loads",
    "spanLoadPanelView": "Loads",
    "spanDeviceDetails": "SPAN Panel",
    "supportHistory": "Support History",
    "supportHistorySearch": "",
    "appTutorial1": "You can refer to all of the system tutorials anytime by navigating to",
    "appTutorial2": "Know Your System",
    "appTutorial": "Know Your System",
    "appTutorial3": "present under",
    "appTutorial4": "System",
    "viewallsystutorial": "View all the system tutorials",
    "connectedAppliances": "Connected Appliances",
    "connectedAppliancesSubtitle": "Monitor and Control your smart appliances",
    "homeConnect": "Home Connect",
    "homeConnectSubtitle": "Monitor and Control your Home Connect enabled appliances",
    "voiceAssistant": "Voice Assistant",
    "voiceAssistantSubtitle": "Enable voice control for Enphase",
    "alexa": "Alexa",
    "googleAssistant": "Google Assistant",
    "solarForecast": "Production Forecast",
    "generator": "Generator",
    "dryContactLoads": "Loads",
    "generatorDevice": "Generator",
    "loadControl": "Load Control",
    "cspantwo": "Load Control",
    "cspan": "Load Control",
    "cspanSubtitletwo": "Control power to your loads ",
    "circuitList": "Circuits ",
    "iqlc": "Load Control",
    "iqlcCircuitList": "Loads",
    "iqlcSubtitle": "Control power to your loads",
    "cspanSubtitle": "Control your loads remotely",
    "loadControlEnphaseSubtitle": "",
    "loadControlEnphase": "Load Control",
    "loadControlSpanSubtitle": "",
    "loadControlSpan": "Load Control ",
    "advanceSettings": "Advanced Settings",
    "advanceBatterySettings": "Advanced Settings",
    "advancedBatterySettings2": "Advanced Settings",
    "loadControlSubtitle": "Control power to your loads",
    "evCharge": "Electric Vehicle Charging",
    "evChargeSubtitle": "Smart suggestions for EV charging",
    "notices": "Notices",
    "newNotices": "Notices",
    "enphaseMini": "Portable Energy System",
    "reports": "Reports",
    "exploreEnphase": "Explore Enphase",
    "exploreEnphaseNewMenu": "Explore",
    "details": "Details",
    "detailSite": "SITE DETAILS",
    "detailsInstaller": "INSTALLER DETAILS",
    "systemDescription": "System Description",
    "systemStatistics": "System Statistics",
    "settings": "Settings",
    "account": "Account",
    "support": "Support",
    "supportFaq": "FAQs",
    "emergencySupport": "Call us now",
    "contactUs": "Contact us",
    "contactSupport": "Write to us",
    "devices": "Devices",
    "addStorage": "Add Storage",
    "devicesOld": "Devices",
    "configure": "Configure",
    "batteryStorage": "Battery Storage",
    "batteryStorageNewMenu": "Battery",
    "connectivity": "Connectivity",
    "connectGateway": "Connectivity",
    "batteryReserve": "Battery Reserve",
    "expertModeEdit": "Expert Mode",
    "eventsHistory": "Events History",
    "backupHistory": "Backup History",
    "outageHistory": "Outage History",
    "event": "Event",
    "events": "Events",
    "totalEvents": "Total Events",
    "totalBackup": "Total Backup",
    "backupDuration": "Backup Duration",
    "hours": "hours",
    "minutes": "minutes",
    "siteDetails": "Site Details",
    "wifi": "Connection Type",
    "liveVitals": "Live Vitals",
    "envoy": "Gateway",
    "envoyNotReport": "Gateway Not Reporting",
    "microInverterNotReporting": "Microinverters Not Reporting",
    "enpowerNotReporting": "System controller Not Reporting",
    "enchargeNotReporting": "Battery Not Reporting",
    "enchargeError": "Battery Error",
    "enpowerError": "System controller Error",
    "microinverters": "Microinverters",
    "stringInverters": "String Inverter",
    "storage": "Battery",
    "reconnectToEnvoy": "Connectivity",
    "configureWiFi": "Configure Wi-Fi",
    "envoyInternetConnection": "To change gateway internet connectivity",
    "enpower": "System Controller",
    "theme": "Theme",
    "darkmode": "Dark Mode",
    "devmode": "Developer Mode",
    "registerOjasBox": "Portable Energy System",
    "appUpdate": "App Update",
    "feedback": "Feedback",
    "logout": "Logout",
    "help": "Help",
    "siteid": "Site ID",
    "visitTommorrowForReport": "Please check back tomorrow. Enphase cloud has not collected the required data to create reports.",
    "email_report": "Email Report",
    "will_send": "Will be sent to",
    "ojasSurroundLight": "Surround Light",
    "ojasSurroundLightSt": "Modify light settings of device",
    "batterySubtitle": "Optimize your battery based on usage and tariff",
    "batteryEmeaSubtitle": "Optimize your battery based on usage",
    "connectivitySubtitle": "Change your gateway internet connectivity",
    "generatorSubtitle": "Optimize your generator based on settings",
    "eventsHistorySubtitle": "View log of key system events",
    "backupHistorySubtitle": "View power outage history",
    "registerOjasBoxSubtitle": "Register your Portable Energy System",
    "accountSubtitle": "Personal Details, Language, Privacy Settings",
    "wifiSubtitle": "Standard Bandwidth, Reports data in every 15 mins",
    "liveVitalsSubtitle": "View live vitals of the system",
    "themeSubtitleOn": "Dark mode is turned on",
    "themeSubtitle": "Dark mode is turned off",
    "devmodeSubtitle": "Developer Mode options",
    "appUpdateSubtitle": "Release notes for latest updates and changelog",
    "appUpdateSuccessSubtitle": "App is up to date",
    "requestReplacement": "Request Replacement",
    "changeShippingAddress": "Change Shipping Address",
    "tariffEditor": "Electricity Rate",
    "tariffEditorNewMenu": "Electricity Rate",
    "currencyConversion": "Currency Equivalent",
    "currencyConversionNewMenu": "Currency",
    "currencySubtitle": "Converts energy data into equivalent currency rates",
    "showCurrency": "Show Currency Equivalent",
    "showCurrencySubtitle": "Turn on to show conversion widget",
    "passwordReset": "Password Reset",
    "tariffAdded": "View/Edit the electricity rate structure of your utility",
    "showCurrencySubtitleOff": "Turn off to hide currency widget",
    "tariffNotAdded": "Electricity rate structure is not added",
    "enlightenManager": "View in Enlighten Manager",
    "sgipIncentive": "Storage Incentive (SGIP)",
    "evCharging": "Electric Vehicle Charging",
    "gridServices": "Grid Services",
    "enphaseHome": "Just moved into a home that has Enphase",
    "systemAccess": "All set-up, but need system access",
    "woSiteSystemAccess": "System Access",
    "enphaseProducts": "Know more about Enphase products",
    "enphaseTeam": "Get help from Enphase team",
    "gridSwitch": "Grid Control",
    "onGrid": "On Grid",
    "chatWithUs": "Chat with us",
    "referFriends": "Refer Friends",
    "referralTnC": "Terms and Conditions",
    "hello": "Hello",
    "homeControls": "Home Controls",
    "systemDetails": "System",
    "pesDetails": "System",
    "community": "Community",
    "settingsMenu": "Settings",
    "enphaseStore": "Enphase Store",
    "upgrades": "Upgrades",
    "services": "Services",
    "generatorSubtitle2": "Control generator when Off Grid",
    "devicesSubtitle": "View all devices and its status",
    "siteDetailsSubtitle": "View Site and Installer details",
    "reportsSubtitle": "Generate and send reports",
    "appSettings": "App Settings",
    "circuits": "CIRCUITS",
    "backup": "BACKUP",
    "accountSettings": "Account Settings",
    "addStorageSubtitle": "Add storage to avoid blackouts",
    "addSolarPanels": "Add Solar Panels",
    "addSolarPanelsSubtitle": "Increase your self-consumption",
    "sgipIncentiveSubtitle": "Apply for SGIP incentive",
    "evChargingSubtitle": "Greener, cheaper, simpler way to charge your Electric Vehicle",
    "gridServicesSubtitle": "Earn benefits by helping the grid with IQ Battery",
    "incentives": "Incentives",
    "accountMenu": "Account",
    "myInformation": "My Information",
    "myNotificationPreferences": "My Notifications",
    "myPrivacy": "My Privacy",
    "myAccessControl": "My Access Control",
    "myInformationSubtitle": "Update personal and system details",
    "myNotificationPreferencesSubtitle": "Manage my notifications",
    "myPrivacySubtitle": "Control how Enphase uses system information",
    "myAccessControlSubtitle": "Manage access to system data",
    "systemSettings": "System Settings",
    "deviceSettings": "Device Settings",
    "wirelessRangeExtender": "Wireless Range Extender",
    "cacheAction": "Clear Local Cache",
    "cacheResult": "Browser energy data cleared",
    "noActiveNotices": "There are no active notices for you",
    "appInfo": "App Information",
    "whatsNew": "What’s New",
    "privacyPolicy": "Privacy Policy",
    "tos": "Terms of Service",
    "rateUs": "Rate Us",
    "gridToggle": {
      "infoPopupTitle": "Sunlight Backup System",
      "infoPopupContentP1": "Your system is a Sunlight Backup system and switching to Off Grid is not recommended outside sunlight time.",
      "pIt1": "When system goes to Off Grid, non-essential loads will be disconnected from power.",
      "pIt2": "Going Off Grid is only possible during the hours when essential loads are scheduled to be powered on in %{scheduledMode}.",
      "pIt3": "Your system may experience a shutdown in Off Grid if there is not enough sunlight.",
      "scheduledMode​": "Scheduled mode​",
      "infoPopupContentP2": "When system goes to Off Grid, loads will be disconnected from power source except the essential one. Switching to Off Grid is not allowed outside the scheduled hours. Your system may experience a shutdown in Off Grid if there is not enough sunlight."
    },
    "ojas": {
      "ojasBoxInfo": "Run the devices on the go with Portable Energy System, your personal portable energy system designed exclusively for home backup and outdoor Off grid use.",
      "ojasTitleQuestion": "Don't have the Portable Energy System yet?",
      "knowurOjas": "Get to know your device",
      "enphasePESSubheading": "Enphase Portable Energy System",
      "enphasePESTitle": "Portable Energy System",
      "enphasePESDescription": "Take your power with you. Energy security and power on the go.",
      "enphasePESConnectDevice": "Connect a Device",
      "enphasePESLearnMore": "Learn More",
      "enphasePESDesc": "PES is designed exclusively for your home backup and outdoor energy needs ",
      "enphasePESKnowMore": "Know more",
      "enphasePESBuy": "Buy",
      "enphasePESConnect": "Connect",
      "registerYourOjasBox": "Register your device",
      "buyOjas": "Buy Portable Energy System",
      "registerOjasInfo": "Make sure your phone’s Bluetooth is turned on.",
      "registerStep1": "Login / Sign up for Enphase account",
      "registerStep2": "Pair your device and phone via Bluetooth​",
      "registerStep3": "Give your device a name​",
      "registerStep4": "Connect it to the Wi-Fi network​",
      "register": "Register",
      "start": "Start",
      "later": "Later",
      "fserialNumber": "Enter Serial No.",
      "enterSeriaNumber": "Enter Portable Energy System Serial No.",
      "collectName": "Device Name",
      "enterBoxName": "Device Name",
      "connectToWiFi": "Wi-Fi Networks",
      "connectToWiFiNotice": "Select your preferred Wi-Fi network and enter password.",
      "takeFewMinutes": "This may take few mins",
      "connectingToWifi": "Connecting to Wi-Fi",
      "pleaseContactSupport": "Please contact support for help",
      "unableToCompleteConnect": "Unable to complete the connect",
      "incomplete": "Incomplete",
      "congratulations": "Congratulations!",
      "incorrectPasswordTryAgain": "Incorrect password. Please try again",
      "yourOjasBox": "Your Portable Energy System",
      "isRegistered": "is registered",
      "startMonitoring": "Start Monitoring",
      "turnOnBluetoothOnNotice": "Turn on your phone’s Bluetooth to connect with your Portable Energy System.",
      "scanningForOjasDevices": "Scanning for Portable Energy System",
      "noOjasDevicesFound": "No Units nearby",
      "noOjasAroundNotice": "No Portable Energy Systems could be found. Make sure that your device is switched on and you are near it. If the problem persist",
      "incorrectPassCode": "Incorrect Code",
      "incorrectPassCodeNotice": "Unable to match the code with any of the surrounding Portable Energy Systems.",
      "capturingDeviceDetails": "Capturing Device Details",
      "capturedDeviceDetails": "Device details captured",
      "capturedDeviceDetailsNotice": "Connect Portable Energy System to Wi-Fi",
      "registrationError": "Registration Error",
      "registrationErrorNotice": "Please retry registration. If problem persist, ",
      "deviceAlreadyRegistered": "Device already registered",
      "deviceAlreadyRegisteredNotice": "This Portable Energy System is already registered to another enphase account.",
      "proceed": "Proceed",
      "rename": "Rename",
      "nameAlreadyExist": "Name already exist",
      "nameAlreadyExistNotice": "This name already exists for an Portable Energy System registered with this account. Please use different name.",
      "bluettoothConnected": "Bluetooth connection eshtablished!",
      "enter4DigitCode": "Enter 4 digit code",
      "bluetoothCodeDetail": "The 4 digit code displayed on your Portable Energy System`s display screen",
      "resendBluetoothCode": "Resend code",
      "connWithOJASBLE": "Bluetooth Devices",
      "noBLEDevicesFound": "No bluetooth devices found",
      "backupTime": "Backup Time",
      "timeRemaining": "Remaining",
      "timeToCharge": "To full",
      "batteryCharge": "",
      "powerSaving": "Power Save",
      "poweredOn": "Powered On",
      "powerOn": "Power On",
      "powerOff": "Power Off",
      "close": "Close",
      "powerSavingHeader": "Device is Power Saving",
      "powerOnHeader": "Device is Powered On",
      "powerSavingSubHeader": "(AC output disabled)",
      "powerSavingContent": "You can remotely power on and enable AC output or shut down the device and disable all the input and output power supply.",
      "powerOnContent": "You can remotely shut down the device and disable all the input and output power supply.",
      "shuttingDown": "Shutting down in",
      "topenojas": "Select Portable Energy System from the drop-$splitdown list to start monitoring.",
      "foundDevice": "Portable Energy System found",
      "pps": "Portable Energy System",
      "auxIn": "AuxIn",
      "acPorts": "AC Ports",
      "dcPorts": "DC Ports",
      "importing": "Importing",
      "grid": "Grid",
      "lightSettings": {
        "light": "Light",
        "on": "Always On",
        "off": "Always Off",
        "auto": "Automatic",
        "onMsg": "Stays On",
        "autoMsg": "Turns on when someone is nearby",
        "offMsg": "Stays Off"
      },
      "ojasConnectivity": {
        "1_title": "Device is not connected to Enphase app!",
        "1_description": "Please ensure your device is turned on and connected to Wi-Fi. If you are nearby your device, you can pair your phone with the device using Bluetooth.",
        "1_action": "Connect using Bluetooth",
        "3_title": "Bluetooth not supported!",
        "3_description": "Bluetooth not supported in your device, please make sure device has Bluetooth and Location options.",
        "4_title": "Turn On Bluetooth",
        "4_description": "Turn on your phone’s Bluetooth to connect with your Portable Energy System.",
        "5_title": "Scanning for Bluetooth devices...",
        "7_title": "Bluetooth Devices",
        "8_title_success": "No bluetooth devices found.",
        "8_title_error": "Problem persisted while scanning.",
        "8_title_noUnits": "No Units nearby",
        "8_description": "No PES devices could be found. Make sure that your device is switched on and you are near it. If the problem persist.",
        "9_title": "Eshtablish Bluetooth connection...",
        "10_title": "Enter proof of possession PIN for",
        "10_subTitle": "Proof of Possession PIN",
        "11_title": "Bluetooth connection established!",
        "11_description_1": "Bluetooth connection with your Portable Energy System:",
        "11_description_2": " is successfully eshtablished.",
        "12_title": "Bluetooth Not-Connected.",
        "12_description_1": "Bluetooth connection with your Portable Energy System:",
        "12_description_2": " is failed, Please try again.",
        "13_title": "Searching for Wi-Fi networks...",
        "14_title": "Connect PES to Wi-Fi",
        "14_description": "Select your preferred Wi-Fi network and enter password.",
        "15_title": "Wi-Fi Networks",
        "15_title_success": "No Network",
        "15_title_error": "Problem persisted while scanning.",
        "15_description": "Keep the Wi-Fi router on and your Portable Energy System unit in the Wi-Fi range.",
        "18_title_1": "Sending Wi-Fi credentials",
        "18_title_2": "Applying Wi-Fi connection",
        "18_description": "provisioned successfully,",
        "19_title": "Incomplete!",
        "19_description": "Unable to complete the connection with Portable Energy System:"
      },
      "deviceId": "Device ID",
      "ojasSettings": {
        "profile": "Profiles",
        "acPorts": "AC Ports",
        "dcPorts": "DC Ports",
        "on": "Turned On",
        "off": "Turned Off",
        "brightnesSettings": {
          "brightness": "Brightness",
          "customBrightness": "Custom Brightness",
          "auto": "Automatically Adjust Brightness"
        },
        "lightSettings": {
          "light": "Light",
          "on": "Always On",
          "off": "Always Off",
          "auto": "Automatic",
          "onMsg": "Stays On",
          "autoMsg": "Turns on when someone is nearby",
          "offMsg": "Stays Off"
        },
        "powerSettings": {
          "mode": "Power Mode",
          "powerON": "Power On",
          "powerOff": "Power Off",
          "powerSave": "Power Save"
        },
        "ojasModes": {
          "on": "All the output AC and DC ports are on. Keep the device in this mode if you have your tools or appliances plugged into the AC port.",
          "save": "Only DC ports are on and ready to power electronic devices. This mode saves power because AC ports are off.",
          "off": "All input and output power sources will be turned off."
        },
        "displaySetting": "Display Settings",
        "deviceSetting": "Device Settings",
        "appSetting": "App Settings"
      }
    },
    "iq8dEditSavings": "Savings",
    "appTutorialPage": {
      'all-topics-empty': 'No topics available',
      'videos-empty': 'No videos available',
      'articles-empty': 'No articles available',
      'noResults': "No results for \"%{searchValue}\""
    }
  },
  "environmentCard": {
    "title": "Environment",
    "label": "Environmental Impact",
    "rightText": "Source: epa.gov",
    "equivalent": "Equivalent",
    "planted": "PLANTED",
    "carbon_offset": "CARBON OFFSET",
    "charged": "CHARGED",
    "trees": {
      "zero": "trees",
      "one": "tree",
      "other": "trees"
    },
    "phone": {
      "one": "phone",
      "other": "phones"
    },
    "tonne": {
      "one": "tonne",
      "other": "tonnes"
    },
    "lb": {
      "one": "lb",
      "other": "lb"
    },
    "ton": {
      "one": "ton",
      "other": "tons"
    }
  },
  "connectionType": {
    "wifi": "Wi-Fi",
    "cellular": "Cell Modem",
    "ethernet": "Ethernet",
    "reportsAt15Mins": "Reports data every 15 mins",
    "reportsAt6Hrs": "Reports data every 6 hrs",
    "idle": "Idle",
    "notAvailable": "Not Available",
    "configureWiFiSettings": "Configure Wireless Settings",
    "configureWiFiSettings2": "Configure",
    "switchToWiFi": "Switch to Wi-Fi",
    "connectToWiFi": "Connect to Wi-Fi",
    "bluetooth": 'Bluetooth',
    "connected": "Connected",
    "notConnected": "Not Connected",
    "bluetoothOff": 'Bluetooth OFF'
  },
  "details": {
    "connection_type": "Connection Type",
    "description": "System description",
    "installer": "Installed by",
    "maintainer": "System maintainer",
    "micros": {
      "one": "Microinverter",
      "other": "Microinverters"
    },
    "acbs": {
      "one": "Battery",
      "other": "Batteries"
    },
    "arrays": {
      "one": "Array",
      "other": "Arrays"
    }
  },
  "notices": {
    "enlighten": "Enlighten"
  },
  "layout": {
    "more_yesterday": "% more than this time yesterday",
    "less_yesterday": "% less than this time yesterday",
    "same_yesterday": "About the same as this time yesterday",
    "more_last_year": "% more than this time last year",
    "less_last_year": "% less than this time last year",
    "same_last_year": "About the same as this time last year",
    "more_yesterday_prev": "% more than this time previous day",
    "less_yesterday_prev": "% less than this time previous day",
    "same_yesterday_prev": "About the same as this time previous day",
    "more_last_year_prev": "% more than this time previous year",
    "less_last_year_prev": "% less than this time previous year",
    "same_last_year_prev": "About the same as this time previous year",
    "system": "System",
    "emptyArray": "No array layout available",
    "storageArray": "Storage Array",
    "solarArray": "Solar Array",
    "contactInstForpersonalizedLayout": "Please contact your installer to get a personalized view of your storage array",
    "cntcInstPopP1": "Storage array shows the image of storage units installed at your home along with their charge levels.",
    "cntcInstPopP2": "Please contact your installer to build the storage array in the Installer Tool Kit application or Enlighten Manager application to get a more personalized view."
  },
  "support": {
    "contactSpan": "Contact SPAN load control Support ",
    "spanSupport": "SPAN Support",
    "enphase": "Enphase support",
    "enphaseLink": "Enphase support",
    "maintainer": "System support and maintenance",
    "maintainerLink": "Contact maintainer",
    "contactEnphase": "Contact Enphase",
    "enphaseSupport": "Enphase Support",
    "ensembleSupport": "Call Enphase Support",
    "writeToUs": "Write to us",
    "visitSupport": "Visit Support",
    "talkToUs": "Talk to us",
    "talkToUsAnytime": "Talk to us anytime",
    "customerSupport24by7": "24/7 Customer support",
    "needHelpTitle": "How can we help",
    "envoyNotReporting": "System or gateway not reporting",
    "microinvertersNotReporting": "Microinverters not reporting",
    "productionIssue": "Production issue",
    "productionDifference": "Difference in per panel production",
    "needMoreHelpTitle": "Need more help",
    "askEnphaseCommunity": "Ask Enphase Community",
    "browseTopics": "Browse all help topics",
    "chatWithUs": "Chat with us",
    "contactUs": "Contact us",
    "helpTopics": "Help Topics",
    "brwsAllFaqs": "Browse all FAQs",
    "askEnphaseCommunitySubtitle": "Reach out to other Enphase customers around you",
    "systemOwnerGuide": "Refer system owner's guide",
    "faq": {
      "usingManualOverride": "Using manual override",
      "understandingEnpower": "Understanding IQ System Controller",
      "understandingEncharge": "Understanding IQ Battery",
      "understandIQCombiner": "Understanding IQ Combiner, Gateway, Comms Kit, and Cell Modem",
      "stormGaurdFeatureDetails": "Storm Guard feature details",
      "settingElectricityRateStructure": "Setting electricity rate structure",
      "recoverShutdownLL": "Recovering from shutdown due to large loads",
      "recoverShutdownCF": "Recovering from shutdown due to communications failure",
      "recoverShutdownBD": "Recovering from shutdown due to battery depletion",
      "PowerHomeInBCK": "Powering home loads in backup",
      "partialHomeBCK": "Partial home backup configuration",
      "monitorUrSys": "Monitoring your system",
      "mngLgApplianceBck": "Managing large appliances in backup",
      "incentivesAvlbTou": "Incentives available to you",
      "grdTrnxToOffGrd": "Grid transition to Off Grid",
      "allHomeBck": "Whole home backup",
      "envLEDstatus": "Gateway LED status",
      "dsgnUrSys": "Designing your system",
      "cntctCustSupp": "Contacting customer support",
      "batSmrtPrfSel": "Battery smart profile selection",
      "accsEnchrgDcswtch": "Accessing battery DC switch",
      "mcrInvNtReprt": "Microinverter not reporting",
      "sysEnvNtReprt": "Gateway not reporting",
      "hwUrSysWrk": "How your system works?",
      "enchrLedStatus": "Battery LED status",
      "noPwNebDo": "My power is out, but grid is on",
      "consBatDurGridOut": "Saving battery life during grid outage",
      "emgSupCallSteps": "Please select 2 for customer support and 1 for system owners. Select 2 in the submenu for storage support.",
      "preLoginCallSteps": "Please select 2 for customer support or select 4 for sales.",
      "sysProdIssue": "System production issue",
      "diffInPerPanProd": "Difference in per panel production",
      "installCellModem": "Guide to install Cell Modem",
      "whatIsEI": "Energy Independence score",
      "howEnHomeEngSysWork": "How Enphase home energy system work?",
      "understandEnv": "Understanding gateway",
      "findEnv": "Finding my gateway",
      "envReplaced": "Gateway has been replaced",
      "rebootEnv": "Restarting or rebooting the gateway",
      "hwChangeEmail": "How do I change my email?",
      "hwResetPasswd": "How do I reset my password?",
      "accessEnvLocalIntf": "Accessing gateway's local interface",
      "envLocIntfLogCred": "Gateway local interface login credentials",
      "hwDisbaleNotification": "How to enable and disable Monthly reports and other email notifications?",
      "MontEngProd": "Monitoring my energy production",
      "whyNotSeeConsumption": "Why am I not able to see my consumption?",
      "hwMonConsumpt": "How do I monitor my home’s consumption?",
      "calEngUsageWoConsumptionMonitoring": "Calculate my energy usage without consumption monitoring",
      "undersNetEng": "Understandng net energy",
      "understTrueUpStmt": "Understanding a true-up statement",
      "diffPaidENLMvsPerpanelDataaoffering": "Difference between paid Enlighten Manager and the free per-panel energy data offering",
      "blkInPerpanMon": "Black panel in per-panel view",
      "gryorBlnkInPerpanMon": "Grey (blank) panel in per-panel view",
      "hwToMovePnl": "How do I move a panel?",
      "hwfindInst": "How do I find a new installer?",
      "whtdoIfonePanelNotreproduc": "What should I do if one of the panels are underproducing or not producing?",
      "haveaSelfPoweredHome": "What does it mean to have a self-powered home?",
      "yourSystemPaysForItself": "How long until your system pays for itself?",
      "enphaseSystemsAreSafe": "Why Enphase systems are safe?"
    },
    "webBackButton": "Back",
    "supportHistory": "Support History"
  },
  "evse": (_evse = {
    "tariffErr": "Please input your %{tariff} details to be able to view the suggested schedule to charge your Electric Vehicle",
    "errfail": "Unable to display suggested schedule. Please try reloading the page after some time.",
    "errcons": "Unable to suggest charging schedule because of insufficient consumption data",
    "errprod": "Unable to suggest charging schedule because of insufficient production data"
  }, _defineProperty(_evse, "errprod", "Unable to suggest charging schedule because of insufficient production data"), _defineProperty(_evse, "errprodcons", "Unable to suggest charging schedule because of insufficient consumption and production data"), _defineProperty(_evse, "addev", "Add an electric vehicle"), _defineProperty(_evse, "addevSub", "Let us know if you are using your Enphase system to charge your EV so that we can provide insights and recommend optimal timelines to charge your vehicle efficiently."), _defineProperty(_evse, "haveEv", "I have an EV."), _defineProperty(_evse, "qbrand", "What is the brand of your EV?"), _defineProperty(_evse, "qbrandErr", "*The above field is mandatory"), _defineProperty(_evse, "qmodel", "What is the model name of your EV?"), _defineProperty(_evse, "diffcharger", "I charge my EV at home using a different company charger"), _defineProperty(_evse, "qcharger", "What is the brand of your charger?"), _defineProperty(_evse, "qcapacity", "What is the battery capacity of your EV (in kWh)?"), _defineProperty(_evse, "notcompulsory", "*this question is not compulsory. You may skip if you don’t know."), _defineProperty(_evse, "qtime", "When do you charge your vehicle?"), _defineProperty(_evse, "morning", "Morning"), _defineProperty(_evse, "afternoon", "Afternoon"), _defineProperty(_evse, "evening", "Evening"), _defineProperty(_evse, "night", "Overnight"), _defineProperty(_evse, "other", "Other (please specify)"), _defineProperty(_evse, "qmiles", "How many miles do you typically drive in a day?"), _defineProperty(_evse, "brand", "Brand Details"), _defineProperty(_evse, "tech", "Technical Details"), _defineProperty(_evse, "operational", "Operational Details"), _defineProperty(_evse, "ev", "Electric vehicle:"), _defineProperty(_evse, "suggsch", "Suggested schedule"), _defineProperty(_evse, "suggschInfo", "The schedule to charge your electric vehicle is suggested based on your battery profile, production forecast and electricity rate."), _defineProperty(_evse, "charge", "To charge your electric vehicle"), _defineProperty(_evse, "weekday", "For Mon, Tue, Wed, Thur & Fri"), _defineProperty(_evse, "weekend", "For Sun & Sat"), _defineProperty(_evse, "everyday", "Everyday"), _defineProperty(_evse, "removeEV", "Remove Electric Vehicle"), _defineProperty(_evse, "userfail", "Unable to display Electric Vehicle details!"), _defineProperty(_evse, "userfailDesc", "We are unable to display your Electric Vehicle details because of some technical issues. Please try again after sometime."), _evse),
  "storage": {
    "stormGuardEnablePopUpHeader": "Enable Storm Guard",
    "stormGuardEnablePopUpFooter": "Do you want to enable Storm Guard?",
    "stormGuardDisablePopUpHeader": "Disable Storm Guard",
    "stormGuardDisablePopUpFooter": "Do you still want to disable Storm Guard?",
    "backupTime": "Backup Time",
    "encharge_battery": "Select a smart profile to control your battery",
    "encharge_battery_emea": "Smart profile to control your battery",
    "savings": "Savings Mode",
    "expert": "Expert Mode",
    "self-consumption": "Self - Consumption",
    "battery_bkup": "Full Backup",
    "savings_text": "Minimize the use of electricity from the grid when the electricity rate is higher. During peak hours, your home is powered in the following order of priority: battery, solar and grid. Any extra solar is exported to the grid.",
    "savings_mode_notSet": "Maximizes your Savings based on electricity rates​",
    "savings_mode_dc_tou": "Solar and battery are used during the day to minimize electricity import from grid.",
    "savings_mode_dc_all_day": "During peak hours solar is exported to the grid. Battery powers your Home till it reaches reserved charge.",
    "viewElectricityRate": "View Electricity Rate",
    "optForDC": "Optimized for Demand Charge Shaving",
    "optForIncExport": "Optimized to Increase Export",
    "consumption_text": "Use stored solar to power your home after the sun goes down. Battery is used when solar is not available.",
    "consumption_text_pv_yield": "Charge battery during peak production hours to optimize PV production. Battery is used when solar is not available.",
    "bkup_text": "100% of the battery is reserved for backup.",
    "reserve": "Reserve",
    "optimization": "Optimization based on",
    "utility_rates": "Utility Rates",
    "increase_consumtion": "Increase Self-Consumption to",
    "max_consumption": "Maximize Energy Independence",
    "optimize_pv_production": "Optimize PV Production",
    "activate": "Activate",
    "active": "Active",
    "save": "Save",
    "edit": "EDIT",
    "error": "Unable to save storage settings.",
    "requestTakingLonger": "Request is taking longer than expected. Please check back later",
    "batterySettingsTakingLonger": "Battery setting update is taking longer than expected. Please check back later",
    "completed": "Battery settings updated successfully.",
    "completedAdvance": "Battery Advanced Settings updated successfully.",
    "requestPending": "Request pending. Awaiting confirmation from gateway. Please check back later.",
    "editRequest": "You have an active request. Please wait for confirmation or cancel that request to proceed with the selection.",
    "editRequestVls": "You have an active request in Battery Advanced Settings. Please wait for confirmation or cancel the request to proceed with the selection.",
    "cancelRequest": "Your request has been cancelled.",
    "updatedSuccesfully": "Updated successfully",
    "timeoutRequest": "Your request has timed out. Please try again later",
    "pendingRequestText": "Pending Request",
    "cancelRequestText": "Cancel Request",
    "pendingText": "Pending",
    "processingText": "Processing",
    "battery_reserve": "of the stored energy will be reserved for backup",
    "cancelFailed": "Failed to cancel task.",
    "noPendingTask": "System doesn't have any pending task to cancel",
    "noEncharges": "System doesn't have batteries",
    "severeWeatherText": "Storm Guard",
    "disabled": "Disabled",
    "enabled": "Enabled",
    "weatherWatchDescription": "Overrides your battery profile to Full Backup mode when a severe weather condition alert is issued for your locality.",
    "disabledModeInfo": "When enabled, Enphase communicates with the {%s} to detect severe weather event alerts and sets your battery profile to full backup mode to provide backup during the event. After the event has passed, the battery profile will return to its previous setting.",
    "enabledModeInfo": "Enphase will communicate with the {%s} to detect severe weather event alerts and will set your battery profile to full backup mode. After the event, the battery profile will return to its previous setting.",
    "activeModeInfo": "Enphase detected a severe weather event alert from the {%s} and your battery profile is set to full backup mode. After the event end time, the battery profile will return to its previous setting.",
    "stormGuardModeInfo": "When %{status}, the Storm Guard feature monitors severe weather condition alerts issued by %{nws}. It overrides your battery profile to ‘Full Backup’ mode if an alert is issued for your locality. This allows your entire battery capacity to be reserved for use during a potential grid outage.%{nl}If an alert is issued for your locality then ‘Storm Alert: On’ is displayed under ‘Profile’ on the Status Page and Live Status Page. At the same time your battery profile will be set to ‘Full Backup’ mode.%{nl}After the alert ends the battery profile will return to its previous settings.",
    "editActiveWeatherAlert": "Storm Guard is Active. Please wait for the event to pass (recommended) or disable the storm guard to proceed with the selection.",
    "enabledToActiveAlert": "Enphase detected a severe weather event alert from the national weather service and your battery profile will be set to full backup mode. After the event end time, the battery profile will return to its previous setting.",
    "activeToEnabledAlert": "The severe weather event has passed and your battery profile will be set to its previous settings.",
    "okayText": "OK, Got it!",
    "disclaimerText": "The Storm Guard feature uses information sourced from the U.S. National Oceanic and atmospheric administration/national weather service, such as (without limitation) severe weather alerts, which information is in the public domain and is not subject to copyright protection. Enphase does not claim to own or control such information. You expressly agree that the use of this feature is at your own risk. And you assume the entire risk related to enabling this feature and any subsequent use. Enphase provides such information via the storm guard feature “as is”, and disclaims any and all warranties, whether express or implied, including (without limitation) any implied warranties of merchantability or fitness for a particular purpose. In no event will Enphase be liable to you or to any third party for any direct indirect, incidental, consequential, special or exemplary damages or lost profile resulting from any use or misuse of this data.",
    "disclaimer": "Disclaimer",
    "agreeText": "Agree & continue",
    "disagreeText": "Disagree",
    "nationalWeather": "National Weather Service (NWS)",
    "dataNotAvailable": "NA",
    "errorTitle": "Error",
    "errorCode": "Error code",
    "thresholdError": "Reporting Error",
    "PopupError": "Your battery S.NO",
    "thresholdPopupError": "did not report during the last reporting cycle. Therefore, the aggregate storage % excludes the storage % for this battery. The battery should start reporting with the next reporting cycle. Please contact support if the issue persists.",
    "errorPopup1": "is having an issue (Error Des:",
    "errorPopup2": ", Error code:",
    "errorPopup3": "). This error event makes the reported storage % of this battery unreliable. Therefore, the aggregate storage percentage mentioned above excludes the storage percentage of this battery. Please contact Support if the issue persists.",
    "contactSupport": "Contact Support",
    "errorSubmitButton": "Ok, Got it",
    "microinvertorError": "Battery microinverter is not active",
    "microinvertorsError": "Battery microinverters are not active",
    "touAlert": "Savings mode works only if your electricity import rate varies with time of use. Please update your electricity import rate to enable this mode.",
    "touAlert2": "Please set your electricity import rate as ToU and Export rate plan as NEM to enable savings mode.%{nl}Savings mode works only if you have Net Energy Metering (NEM) and your electricity rate varies with Time-of-Use (ToU).",
    "touAlert3": "Please set your electricity import rate as ToU to enable savings mode",
    "touAlert4": "Please set your electricity export plan to enable savings mode",
    "updateElectricityRate": "Update Electricity Rate",
    "batteryChangeAlert": "Your battery profile was changed to Self Consumption Mode as Savings mode works only if your electricity import rate varies with time of use.",
    "batteryChangeAlert2": "Your battery profile was changed to Self Consumption mode as Savings mode works only if you have Net Energy Metering (NEM) and your electricity rate varies with Time-of-Use (ToU).",
    "viewDetails": "View Details",
    "ok": "Ok",
    "systemRequest": "System generated requests cannot be cancelled.",
    "featureDetailsButton": "Storm Guard Feature Details",
    "stormGuardEnablePopUp": "Enabling Storm Guard allows your full battery capacity to be reserved for use during severe weather related grid outage.",
    "stormGuardDisablePopUp": "Disabling Storm Guard is not recommended as it helps you stay protected from severe weather related grid outages.",
    "batterySmartProfile": {
      "title": "Battery Smart Profile Selection",
      "description": "Learn how to choose the right profile for your battery system",
      "viewDetails": "View details"
    },
    "reserveDisclaimer": "Battery reserve cannot be set below  %{minSoc}%. A minimum of  %{minSoc}% energy is stored in the battery to power your critical home loads during a grid outage.",
    "eIpopDesc": "%{enabled}: Your battery will discharge to save money during peak hours when electricity rates are high. Once that is done, Energy Independence is prioritized. This will increase your energy self-sufficiency until you hit the reserve charge of the battery. Your battery will charge from solar in the morning to get ready for the next peak period.%{nl}%{disabled}: Your battery will discharge only during peak hours when electricity rates are high.  During other times, your battery will be idle or will charge from solar in the morning to get ready for the next peak period.",
    "errActiveCostSave": "Please activate Savings Mode to use this feature",
    "eiDescreption": "Energy Independence after peak hours",
    "advSetting": {
      "cfg": {
        "title": "Charge battery from the grid",
        "descrDisable": "Your battery charges from Solar.",
        "descrEnabled": "Your battery charges from Solar. It may also charge from the grid when your battery is in Full Backup mode or when battery charge is below the reserve capacity in Savings or Self-Consumption modes.",
        "descrEnabledFR": "Your battery will charge from grid in the scheduled interval. It will not discharge during this period.",
        "popUpDescr": "%{enabled}: Your battery charges from Solar. It may also charge from the grid when your battery is in Full Backup mode or when battery charge is below the reserve capacity in Savings or Self-Consumption modes.%{nl}%{disabled}: Your battery charges from Solar.",
        "popUpDescrFR": "%{enabled}: Your battery will charge from grid in the scheduled interval. It will not discharge during this period. %{nl}%{disabled}: Your battery charges from Solar.",
        "disclaimer": "Using a non-renewable energy source to charge your Enphase Storage system may affect your eligibility to claim the ITC. Please consult your tax advisor for more information.​",
        "dlgTitle": "Charge from Grid?",
        "dlgInfo": "Once enabled, your battery will charge from grid in the scheduled interval. It will not discharge during this period. Please check the utility regulations before enabling this option.",
        "selfDeclrFR": "I understand that grid charging might be against utility regulations.",
        "selectSchedule": "Select the schedule to charge your battery from the grid.",
        "titleFR": "Schedule charging from grid",
        "saveSch": "Save Schedule",
        "chargeSch": "Charging Schedule",
        "selfDeclr": "I understand that my eligibility to claim Investment Tax Credit may be affected.​",
        "disclaimer_itk": "Using a non-renewable energy source to change Enphase Storage system may affect eligibility to claim the ITC. Please consult with homeowner for his/her approval.",
        "selfDeclr_itk": "Homeowner understands that eligibility to claim Investment Tax Credit may be affected.",
        "activeStormAlert": "Storm alert is on for your system. Please wait for the alert to end to update this setting."
      }
    },
    "exM": {
      "title": "Expert Mode",
      "subTitle1": "Schedule battery profile",
      "subTitle2": "Scheduled battery profiles",
      "schedule": "Schedule",
      "tariffNotSetDlgtitle": "Electricity Rate Not Set",
      "tariffNotSetDlgContent": "Please set your electricity rate to enable Savings Mode.%{nl}Enphase needs your rate details to determine best schedule for your battery.",
      "setRate": "Set Rate",
      "tariffUpdateDlgtitle": "Update Electricity Rate",
      "tariffUpdateDlgContent": "Savings mode works only if you have Net Energy Meetering (NEM) and your electricity rate varies with Time-of-Use (ToU).",
      "updateRate": "Update Rate",
      "setNemDlgTitle": "Electricity Export Rate Not Set",
      "setNemDlgContent": "Please set your electricity import rate as NEM to enable this mode.",
      "setNemCta": "Set as NEM",
      "preview": "Preview",
      "addBatProfile": "Add Battery Profile",
      "pViewPop": {
        "l1": "Graph represents the scheduled battery profiles for 24 hrs period.",
        "l2": "The battery reserve is applicable for Self-Consumption and Savings Mode only. In Full Backup, your battery reserve will be 100%.",
        "l3": "Maximizes your Energy Independence ​",
        "l4": "Maximizes your Savings based on electricity rates​",
        "l5": "Conserves 100% battery energy for backup",
        "batteryProfiles": "Battery Profiles"
      },
      "batReserveDisclaimer": "The battery reserve is applicable for Self-Consumption and Savings Mode only. In Full Backup, your battery reserve will be 100%."
    },
    "prfAssist": {
      "t0": "Already in recommended profile",
      "t1": "We Recommend",
      "t2": "Savings Mode, with a low battery reserve and Energy Independence after peak hours enabled.",
      "t3": "Savings Mode, with a high battery reserve and Energy Independence after peak hours disabled.",
      "t4": "Self-Consumption, with a low battery reserve.",
      "t5": "Self-Consumption, with a high battery reserve.",
      "t6": "Full-Backup.",
      "t7": "Savings Mode, with a high battery reserve and Energy Independence after peak hours disabled.",
      "t8": "Self-Consumption, with a high battery reserve.",
      "batResText": "Battery reserve between",
      "learnHowEmea": "Learn about battery profile",
      "learnHow": "Learn about battery profiles",
      "editPref": "Change my goals",
      "c1": "Save Money",
      "c1Sub": "Maximize savings on electric bills",
      "c2": "Energy Independence",
      "c2Sub": "Self-power your home with clean energy",
      "c3": "Backup",
      "c3Sub": "Stay powered during an outage",
      "p1": "First Priority",
      "p2": "Second Priority",
      "optional": "Optional",
      "ques": "What goals do you have for your energy system?",
      "priority": "Please drag and drop the goals in order from most to least important.",
      "ftrpTutorialText": "Select and drag the cards up or down to arrange as per your priority. First card from the top represents the higher priority.",
      "updateBatteryProfile": "Update battery profile",
      "activatedSavingsMode": "Your battery is currently in Savings Mode with a %{soc}% reserve and Energy Independence after peak hours is %{eiStatus}.",
      "activatedSelfConsumptionMode": "Your battery is currently in Self-Consumption with a %{soc}% reserve.",
      "activatedSavingsModeWithoutSoc": "Your battery is currently in Savings Mode and Energy Independence after peak hours is %{eiStatus}.",
      "activatedSelfConsumptionModeWithoutSoc": "Your battery is currently in Self-Consumption.",
      "activatedFullBackupMode": "Your current battery profile is Full Backup.",
      "activateProfile": "Do you want to activate the recommended profile?"
    }
  },
  "envoy": {
    "all": "All Gateways",
    "pvAll": "All",
    "dropDwnHelper": "Show data from",
    "envSN": "Gateway SN:",
    "reconnect": "Please reconnect your gateway.",
    "extraContent": "In the meantime, if you are in the proximity of your system, you can connect locally with gateway to view current status.",
    "btnText": "Learn how to connect to gateway's Wi-Fi",
    "getHelp": "Get your gateway connected back to home Wi-Fi",
    "envoyConfirmation": "Connect to gateway via AP mode to proceed.",
    "title": "We have found that you are using Envoy-S or IQ Gateway and using Wi-Fi.",
    "steps": "Follow the steps to connect gateway to Wi-Fi network",
    "steps_ap": "Follow the steps to connect to gateway network",
    "ap_button": "Press AP mode button",
    "ap_modeDescription": "Briefly press and release (do not hold) the gateway menu button below the phone icon. This will enable AP Mode on your gateway which creates a wireless network you can join with your phone.",
    "disable_data": "Turn off mobile data",
    "disable_dataDescription": "Turn off the mobile data (cellular data) from your mobile device settings. Go to Settings > Mobile Data and switch it off.",
    "envoy_network": "Join gateway’s network",
    "envoy_description": "Join the gateway’s network using your phone Wi-Fi settings. Envoy_029655 is the name of the mini-network you will join, where “029655” are the last six digits of your gateway’s serial number.",
    "home_wifi": "Connect gateway to home Wi-Fi",
    "wifi_description": "Tap the configure Home Wi-Fi button, select your home network and enter the Wi-Fi password.",
    "configure_wifi": "Configure home Wi-Fi",
    "cancel": "Cancel",
    "stickyNotification": "Please don't tap back button or swipe kill the app (you can minimize it) while you are attempting to re-connect your gateway.",
    "enter_password": "Enter Password",
    "password": "Password",
    "incorrect_password": "Incorrect password",
    "wifi_failureMsg": "Gateway couldn’t connect to your Wi-Fi network",
    "wifi_successMsg": "Gateway is connected to Wi-Fi successfully",
    "envoyConnectToCellular": "You may now disconnect your mobile device from your gateway network and connect it to your Wi-Fi / enable your mobile data.",
    "envoyToastMessage": "Your gateway is connected successfully. But it may take upto 30 mins for the status of your gateway to get updated.",
    "wifi_congratsMsg": "Congratulations! You're back online. Now you can re-connect your mobile to the home wifi network.",
    "tryagain": "Try Again",
    "okay": "Ok, Got it",
    "failedToFetchWiFiNetworks": "Trouble fetching Wi-Fi networks. Please try again after sometime.",
    "noWifiNetworkFound": "No Wi-Fi network found. Reboot your Wi-Fi router and try again.",
    "option2": "If the above steps do not work, learn how you can do it manually",
    "learnhow": "Learn How",
    "ensureOn": "Ensure gateway is powered On",
    "connectToPower": "Make sure your gateway is connected to a power source."
  },
  "whatsnews": {
    "monitorTitle": "Monitor",
    "monitorContent": "See your system status at-a-glance with key metrics on a single screen",
    "trackTitle": "Track",
    "trackContent": "Track and navigate your energy production and consumption trends in daily, monthly, yearly, or lifetime view",
    "reportTitle": "Report",
    "reportContent": "Run reports of energy production and usage from the app in daily, weekly, monthly or custom period of your choice"
  },
  "theme": {
    "instructions": "Current color scheme",
    "night": "Night",
    "day": "Day"
  },
  "devices": {
    "loadController": "IQ Load Controller",
    "span": "SPAN Panel",
    "model": "Model",
    "dryContactLoads": "Loads",
    "no_dryContactLoads": "No devices",
    "no_undefined": "No devices",
    "generator": "Generator",
    "noDeviceFound": "No device found",
    "searchMicroinverters": "Search for Microinverters SN",
    "serialNumber": "SN",
    "configure": "Configure",
    "connect": "Connect",
    "envoy": "Gateway",
    "microinverters": "Microinverters",
    "microinverter": "Microinverter",
    "stringInverters": "String Inverter",
    "storage": "Battery",
    "enpower": "System Controller",
    "skuNumber": "SKU",
    "firmwareVersion": "Firmware",
    "cycleCount": "Cycle Count",
    "cycleCountInfo": "Cycle count for a battery is the total number of completed charge and discharge cycles. It is calculated as total accumulated energy divided by the usable capacity of the battery. The number shown here represents the completed cycles.",
    "status": "Status",
    "array": "Array",
    "help": "Help",
    "not_reporting": "Not Reporting",
    "not_reporting_lowercase": "not reporting",
    "normal": "Normal",
    "home": "Home",
    "no_microinverters": "No microinverter found",
    "no_storage": "No storage found",
    "no_envoy": "No gateway found",
    "no_enpower": "No system controller found",
    "wirelessRangeExtender": "Wireless Range Extender",
    "no_wirelessRangeExtender": "No Wireless Range Extender found",
    "lastReported": "Last reported",
    "manufacturer": "Manufacturer Name",
    "startType": "Start Type",
    "fuelType": "Fuel Type",
    "modelNumber": "Model Number",
    "onOffCycles": "Total on/off cycles",
    "maintainenceInfo": "Maintenance Information",
    "maintainenceSub": "Update these details to get notified on your generator maintenance and fuel requirements.",
    "lastMaintainenceDate": "Last maintenance date",
    "lastRefuellingDate": "Last refuelling date",
    "lastRefuellingTime": "Last refuelling time",
    "lastMaintainenceTime": "Last maintenance time",
    "litresOfFuel": "Liters of fuel filled",
    "additionalInfo": "For additional information",
    "statistics": "Yours statistics since last maintenance:",
    "timeElapsed": "Time elapsed:",
    "cycles": "On/Off cycles:",
    "runningHours": "Running time:",
    "Days": "days",
    "update": "Update",
    "clickHere": "click here",
    "savedSuccessfully": "Your settings are saved successfully.",
    "loads": {
      "status": "Status",
      "smartControl": "Smart Control",
      "auxillaryContact": "Auxillary Contact"
    },
    "devicegenerator": {
      "on": "On",
      "off": "Off"
    },
    "connected": {
      "true": "Connected to Enphase cloud",
      "false": "Disconnected from Enphase cloud"
    },
    "envoyConnected": {
      "wait": "Searching for gateway...",
      "true": "Gateway successfully detected.",
      "false": "Gateway not detected."
    },
    "stepOne": "Please connect directly to the gateway. To do this, first push the connection button on the gateway.",
    "stepTwo": "Then go to your wifi settings and connect to the gateway’s network:",
    "stepThree": "Once connected return to this screen. You will be temporairily disconnected from the internet.",
    "connectLocally": "Connect Locally",
    "connectEnvoy": "Connect to gateway using",
    "connectEnvoyUser": "Username",
    "connectEnvoyPassword": "Password",
    "notAllowAPMode": "The gateway does not support local connectivity.",
    "localEnvoyConnected": {
      "true": "Gateway successfully detected",
      "false": "No gateway found on the local network",
      "wait": "Wait..."
    },
    "envoyPwd": {
      "urenvPwd": "Your gateway password",
      "retrivePwd": "to retrieve your gateway password.",
      "infoTitle": "Gateway Password",
      "infoDescription": "You will need this password to reconnect your gateway to your Wi-Fi. This typically happens when the Wi-Fi password or service provider has changed.",
      "infoLearnMore": "Click here to learn more"
    },
    "ensemble3_0Provisioning": {
      "bleOff": "Turn on your phone’s Bluetooth to connect with your IQ Gateway",
      "tryApMode": "Try AP Mode",
      "gatewayNotFound": "IQ Gateway not discoverable. Make sure that your IQ Gateway is nearby and turned On.",
      "bleNotSupported": "Bluetooth not supported",
      "bleNotSupportedDesc": "Bluetooth not supported in your device, please make sure device has Bluetooth and Location options.",
      "bleConnected": "Bluetooth Connected",
      "scanningGateway": "Scanning for IQ Gateway",
      "fewMints": "This may take few mins",
      "noWifi": "No Wifi devices found",
      "password": "Password",
      "gatewayConnected": "IQ Gateway is connected to Wi-Fi successfully.",
      "okGotIt": "Ok, got it",
      "noGateway": "IQ Gateway Not Found",
      "gatewayNearByWarning": "Make sure your Gateway is nearby and turned on.",
      "noNetwork": "No Network",
      "wifiRouterWarning": "Keep the Wi-Fi router on and your IQ Gateway in the Wi-Fi range.",
      "connectionError": "Connection Error",
      "turnOn": "Turn On",
      "failedWifiConnect_1": "Failed to connect with the Wi-Fi network. Please ",
      "failedWifiConnect_2": "Contact Support",
      "failedWifiConnect_3": " for help.",
      "failedIQConnect_1": "Failed to connect with the IQ Gateway.Please ",
      "failedIQConnect_2": "Contact Support",
      "failedIQConnect_3": " for help.",
      "bleDevices": "Bluetooth Devices",
      "wifiNetworks": "Wi-Fi Networks",
      "connectBle": "Connect to Bluetooth",
      "gatewayToWifi": "Connecting IQ Gateway to Wi-Fi...",
      "bleStatus": "Checking Bluetooth Status...",
      "searchingWifi": "Searching for Wi-Fi Networks...",
      "connectingBle": "Connecting to Bluetooth",
      "turnOnBle": "Turn On Bluetooth",
      "tryAgain": "Try Again",
      "wifiSsIdConfigFailedDesc": "An unknown error occurred while connecting to the Wi-Fi network. Please try later or connect to a different network.",
      "wifiCommunicationError": "Wi-Fi Communication Error",
      "wifiCommunicationErrorDesc": "Unable to establish connection with IQ Gateway’s BLE module. Please try later.",
      "networkNotFound": "Network Not Found",
      "networkNotFoundDesc": "The network you are trying to connect to is not found. Make sure the Wi-Fi router is on or try another network."
    }
  },
  "notification": {
    "offline": "Offline",
    "apmode": "AP Mode"
  },
  "siteempty": {
    "nosystemassociated": "Your account is not currently associated with any systems.",
    "systemowner": "Are you an Enphase system owner?",
    "contactyourinstaller": "Contact your installer to verify the account that is associated with your system.",
    "interestedonsystem": "Are you interested in an Enphase system?",
    "initiatetransferofwarranty": "Initiate transfer of warranty in case you have bought a property with an Enphase system.",
    "applytransferownership": "Apply for a transfer of ownership here.",
    "ownershiptransfer": "Ownership Transfer",
    "visita": "Visit a",
    "publicsystempage": "public system page",
    "monitoringexperience": "to see the Enphase monitoring experience."
  },
  "recaptcha": {
    "verification_failed": "reCAPTCHA verification failed, please try again.",
    "recaptcha_unreachable": "Oops, we failed to validate your reCAPTCHA response. Please try again."
  },
  "mobile_app_rating": {
    "enjoying_app": "Enjoying Enphase app?",
    "rate_on_play_store": "Rate your experience",
    "rate_on_play_store2": "On the play store",
    "rate_us": "Rate us now",
    "may_be_next": "May be next time"
  },
  "consumptionMtr": {
    "btnText": "Add Consumption Meter",
    "infoText": "Consumption Meter helps to track your overall energy usage"
  },
  "replacement": {
    "microinverter_not_reporting": "Microinverters are not reporting.",
    "batteryWarning": 'This can occur if the wireless communication between your gateway and the battery is not robust. This may be a temporary glitch and should recover soon.',
    "controllerWarning": 'This can occur if the wireless communication between your gateway and the system controller is not robust. This may be a temporary glitch and should recover soon.',
    "batteryError": 'Battery is not reporting data.',
    "controllerError": 'System Controller is not reporting data.',
    "contactMaintainer": 'Contact your maintainer for help.',
    "systemWarning": "System Warning",
    "array_details": "Array Details",
    "replacement_warranty1": "",
    "replacement_warranty": "Microinverters are under warranty and eligible for replacement.",
    "shipping_address": "Shipping Address",
    "site_address": "Site address",
    "change": "CHANGE",
    "select_microinverters": "SELECT MICROINVERTERS",
    "serial_number": "Search for serial number",
    "status": "Status",
    "normal": "Normal",
    "not_reporting": "Not Reporting",
    "submit_request": "Submit Request",
    "dear": "Dear",
    "replacement_message1": "You may need to contact your Installer",
    "replacement_message2": "get the replacement done once the replacement device gets shipped. There may be replacement charges from your installer.",
    "request_submitted": "Your return request submitted successfully.",
    "response_message": "Use the request ID to track the status of replacement when you contact support.",
    "request_id": "Request ID",
    "ok": "OK, got it",
    "replacement_delivery": "Replacement will be delivered to your site",
    "replacement_delivery_installer": "Replacement will be delivered to your local installer",
    "installer_address": "INSTALLER ADDRESS",
    "understand": "I understand",
    "continue_button": "Continue",
    "error_message": "Failed to generate Request ID.",
    "failed_to_fetch": "Failed to fetch microinverters. Please try again",
    "change_address": "Change shipping address"
  },
  "tariff": {
    "tariff": "Tariff",
    "tariffNotAdded": "Tariff is not added",
    "tariffNotSet": "Tariff not set",
    "tariffType": "Tariff Type",
    "buying": "Buying",
    "selling": "Selling",
    "flat": "Flat Rate",
    "tou": "Time of Use",
    "tiered": "Tiered",
    "copyFromBuyingTariff": "Copy From Buying Tariff",
    "copyFromSellingTariff": "Copy From Selling Tariff",
    "dayBasedTariff": "Does your tariff vary through the day?",
    "unitsBasedTariff": "Does your tariff vary based on units consumed?",
    "seasonalTariff": "Does your tariff vary seasonally?",
    "weekendTariff": "Does your tariff vary on weekends?",
    "baseRateTariff": "What is the base rate?",
    "flatLabel": "Energy cost are fixed through the day.",
    "touLabel": "Energy cost vary during peak hours.",
    "tieredLabel": "Energy cost vary as the unit consumption increases.",
    "rate": "Rate",
    "addSeason": "Add Season",
    "season": "Season",
    "next": "Next",
    "noSeasonWeekend": "Tariff neither varies seasonally nor on weekends.",
    "weekendOnly": "Tariff varies only on weekends.",
    "seasonAndWeekend": "Tariff varies seasonally and on weekends.",
    "seasonOnly": "Tariff varies only seasonally.",
    "infoText": "Info",
    "baseRate": "Base Rate",
    "remove": "Remove",
    "from": "From",
    "to": "To",
    "addPeak": "Add Peak",
    "tariffDetails": "Tariff Details",
    "off-peak": "Off-Peak",
    "above": "Above",
    "below": "Below",
    "between": "Between",
    "and": "and",
    "weekdays": "weekdays",
    "weekend": "weekend",
    "winter": "Winter",
    "summer": "Summer",
    "fall": "Fall",
    "spring": "Spring",
    "confirmAndSave": "Confirm & Save",
    "buyingTariff": "Buying Tariff",
    "sellingTariff": "Selling Tariff",
    "edit": "Edit",
    "offPeak": "Off-Peak",
    "peak": "peak",
    "period": "peak",
    "addTier": "Add Tier",
    "tier": "Tier",
    "yesLabel": "yes",
    "noLabel": "no",
    "manualConfiguration": "Manual Configuration",
    "added": "added",
    "modified": "modified",
    "successfully": "successfully",
    "alreadySelected": "is already selected",
    "alreadyAdded": "is already added",
    "buyingTariffAdded": "Buying Tariff added successfully",
    "sellingTariffAdded": "Selling Tariff added successfully",
    "buyingTariffModified": "Buying Tariff modified successfully",
    "sellingTariffModified": "Selling Tariff modified successfully",
    "buyingTariffReset": "Buying Tariff reset successfully",
    "sellingTariffReset": "Selling Tariff reset successfully",
    "reset": "Reset",
    "resetConfirmationText": "Are you sure you want to reset the tariff details?",
    "resetErrorText": "Unable to reset tariff details",
    "updateErrorText": "Unable to update tariff details",
    "tariffErrorText": "Invalid entry. This value already exists in Tier ",
    "tierInvalidEntry": "Invalid entry. The value should be greater than \"Tier 1\"",
    "timeInvalidEntry": "Invalid entry. The value should be greater than \"From\"",
    "invalidValue": "Value should be greater than 0"
  },
  "currency": {
    "currencyEquivalent": "See currency equivalent of energy values",
    "currencyConversion": "Set currency conversion factor",
    "currencyInfo": "The reported currency value is indicative. Taxes, fees, tiered, demand, or time of use pricing is not considered.",
    "currencyFactor": "Currency Conversion Factor",
    "currencyFactorSubtitle": "Energy data is converted to their currency equivalent value by multiplying them with the currency conversion factor.",
    "currencyNote": "Note: The reported currency value is indicative. Taxes, fees, tiered, demand, or time of use pricing is not considered.",
    "conversionFactor": "Conversion Factor",
    "currencyEquivalentHeader": "Currency Equivalent",
    "energyImported": "Energy Imported",
    "energyExported": "Energy Exported",
    "netEnergyImported": "Net Energy Imported",
    "netEnergyExported": "Net Energy Exported",
    "currencyConversionHeader": "Currency Conversion",
    "confirmationMessage": "Do you wish to continue without saving the changes?",
    "confirmationYes": "Yes",
    "confirmationNo": "No",
    "invalidInput": "Invalid input"
  },
  "demo": {
    "appDemo": "App Demo",
    "message": "This is a demo app",
    "enphaseInstaller": "Enphase Installer",
    "mainHeader": "All In One Smart Energy System",
    "subHeader": "Get Solar and Storage",
    "getStarted": "Get started",
    "appDemoDesc": "Tap to see how a system works",
    "loginDesc": "For registered users",
    "selectLanguage": "Select Language"
  },
  "connectionBandwidth": {
    "low": "Low-Bandwidth. Reports data every 6 hours",
    "high": "Standard-Bandwidth. Reports data every 15 minutes"
  },
  "release_notes": {
    "appUpdateHeading": "New update for your Enphase app",
    "appUpdateSuccessHeading": "Your Enphase app was updated.",
    "later": "Later",
    "updateNow": "Update now",
    "update": "Update",
    "whatsNew": "Here’s what’s new",
    "askWhatsNew": "What’s new?",
    "new": "New",
    "version": "Version",
    "readMore": "Read more"
  },
  "storageCapacity": {
    "availableEnergy": "Available Energy",
    "totalStorage": "Total Storage",
    "encharge": "IQ Battery",
    "acBattery": "AC Battery",
    "of": "of",
    "availablePower": "Available Power",
    "activeMicroinverters": "Active Microinverter(s)",
    "activeEncharge": "Active Battery(s)",
    "microinverters": "Microinverter(s)"
  },
  "siteImage": {
    'siteImagePopUpHeading': "Upload a site image of your choice",
    "selectImage": "Select Image",
    "imageSizeError": "*Image size should be less than 5MB",
    "hide": "Hide",
    "apply": "Apply",
    "hideSiteImage": "Hide Site Image",
    "hideSiteImageDesc1": "Site image will not be displayed on Status page. You can change the preference by going to Menu -> System -> Site Details.",
    "hideSiteImageDesc2": "Do you want to proceed?",
    "uploadSuccessToast": "Your site image is updated successfully",
    "maxImageLimit": "You can upload up to four images for your site. Please delete an image to add a new one.",
    "okGotIt": "OK, Got it!",
    "imageSIzeErrorSiteDetails": "Image size should be less than 5 MB. Please upload a different image.",
    "apiError": "Unable to complete the request. Please try again later",
    "displayOnStatusPage": "Display on Status page",
    "displayOnStatusPageWarning": "Are you sure you want to update the image on Status page?",
    "displayOnStatusPageNote": "Note: The image will be auto-adjusted to display. You can always readjust it on the Status page",
    "deleteSiteImage": "Delete Image",
    "deleteSiteImageWarning": "Are you sure you want to delete the image?",
    "imageDeleteSuccess": "Image is successfully deleted",
    "imageUploadSuccess": "Image is successfully uploaded",
    "imageUploadSuccessStatusPage": "Image successfully updated on Status page",
    "displayedOnStatusPage": "Displayed on status page",
    "uploadImage": "Upload Image",
    "imagePreferenceSaved": "Your site image preference is saved",
    "siteImage": "Site Image",
    "statusPageMaxImagePopUpDesc1": "You can upload up to four images for your site. Please delete an image from ",
    "statusPageMaxImagePopUpDesc2": " to add a new one here",
    "addSiteImage": "ADD SITE IMAGE",
    "wrongFileType": "Please upload a JPEG or PNG  image only"
  },
  "nps": {
    "question": "How is your experience with us?",
    "description": "Based on your recent experience with Enphase, how likely are you to recommend Enphase to a friend or collague?",
    "dontAskAgain": "Don't ask me again",
    "notNow": "Not now",
    "notLikely": "Not Likely",
    "mostLikely": "Most Likely",
    "confirmationHeader": "Thank you for your response! Help us understand your response better.",
    "surveyButton": "Take a 2 min survey",
    "notInterested": "Not interested",
    "survey": "Survey",
    "internetError": "Please check your internet connection and try again.",
    "rateEnphaseTitle": "Rate Enphase",
    "rateEnphaseDescription": "How likely are you to recommend Enphase to a friend or colleague?",
    "rateInstallerTitle": "Rate Your Installer",
    "rateInstallerDescription1": "How likely are you to recommend",
    "rateInstallerDescription2": "to your friend or colleague?",
    "feedbackSuccess": "Thank you for your valuable feedback.",
    "ratingSuccess": "Thank you for your feedback.",
    "feedbackEnphaseTitle": "Your Enphase Rating",
    "feedbackInstallerTitle": "Your Installer Rating",
    "detractors": "What could we be doing better?",
    "passive": "What could we do to improve your experience?",
    "promoters": "Help us by explaining your score?",
    "legalDisclaimer": "Your name and feedback/comments will be shared with the installers."
  },
  "liveStatus": {
    "title": "Live Status",
    "cfgMsg": "Batteries might charge from grid as you have enabled %{cfglink} setting.",
    "cfgFiller": "Charge battery from the grid",
    "cfgVls": "Batteries might charge from grid as your battery charge is below the shutdown level.",
    "learn": "Learn",
    "pvOnlyCta": "%{learn} how you can optimize & track your energy usage using consumption metering",
    "subTitle": "View real-time power",
    "offlineMsg": "Use LIVE STATUS when Offline",
    "streamingLocally": "Streaming Locally from gateway",
    "closingMinutes": "Closing in",
    "solar": {
      "title": "Solar",
      "producing": "Producing",
      "energyProducing": "Energy Producing"
    },
    "home": {
      "title": "Home",
      "consuming": "Consuming",
      "energyConsuming": "Energy Consuming"
    },
    "grid": {
      "title": "Grid",
      "gridConnectivity": "Grid connectivity",
      "waiting": "Waiting for Information",
      "unknown": "Grid status unknown",
      "notAvailable": "Grid is not available",
      "systemConnected": "System is On Grid",
      "notSystemConnected": "System is Off Grid",
      "outage": "Grid Outage",
      "updating": "Updating Grid Status",
      "exporting": "Exporting",
      "importing": "Importing",
      "notConnected": "Not Connected",
      "offGrid": "Off Grid",
      "onGrid": "On Grid",
      "goOnGrid": "Go On Grid",
      "goOffGridDisabled": "Off Grid Not Allowed",
      "goOffGrid": "Go Off Grid",
      "gridUpdatingMessage": "Grid status confirmation is taking longer than expected. Please check back later.",
      "gridConnectedMessage": "Your system is now connected to the Grid",
      "gridDisconnectedMessage": "Your system is now disconnected from the Grid",
      "disconnectingGrid": "Disconnecting from Grid...",
      "connectingGrid": "Connecting to Grid...",
      "unableToConnect": "Unable to connect with gateway",
      "initialisingOnGrid": "Initialising Grid Control...",
      "gridOutage": "System is Off Grid due to grid outage",
      "gridOutageToastAuto": "You cannot go On Grid due to power outage. When power is restored, system will reconnect to the grid",
      "gridOutageToastUser": "You cannot go On Grid due to power outage. You can control grid connection once utility grid is available"
    },
    "generator": {
      "title": "Generator",
      "onGenerator": "Generator On",
      "offGenerator": "Generator Off",
      "unknown": "Generator Status Unknown",
      "notConnected": "Not Connected",
      "genDisconnecting": "Disconnecting...",
      "waiting": "Waiting",
      "updating": "Updating"
    },
    "fuelCell": {
      "title": "Fuel cell",
      "on": "Fuel Cell On",
      "off": "Fuel Cell Off",
      "warmingUp": "Fuel Cell Warming Up",
      "coolDown": "Fuel Cell Cool Down",
      "unknown": "Fuel Cell Status Unknown",
      "notConnected": "Not Connected",
      "genDisconnecting": "Disconnecting...",
      "waiting": "Waiting",
      "updating": "Updating"
    },
    "systemNotReporting": {
      "title": "System Controller Not Reporting",
      "subTitle": "We are not able to show the live data as your system controller is not reporting to the gateway. This may be a temporary glitch and should recover soon."
    },
    "envoy": {
      "connecting": "Connecting to gateway...",
      "connectingToOjas": "Connecting to Portable Energy System...",
      "notAbleToConnect": "Not able to connect",
      "notAbleToConnectMultiEnv": "Not able to connect to gateway SN:",
      "negativeConsumptionTitle": "Communication Error",
      "negativeConsumptionDesc": "We are not able to show complete live status due to communication loss between your devices. This is a temporary glitch and should recover soon"
    },
    "onDifferentNetwork": "Your gateway and this device are on a different network",
    "connectOnSameNetworkorAPMode": "Connect your gateway and device to the same network or enable AP mode on your gateway to connect this device to the %{ssid} Wi-Fi network​.",
    "connectOnSameNetwork": "Connect this device to the %{ssid} Wi-Fi network then try again to view the live status in Offline mode.",
    "apModeTutorial": "AP Mode Tutorial",
    "apMT1": "Press and release (do not hold) the ",
    "apMT2": "AP Mode Button",
    "apMT3": " until the AP Mode LED (",
    "apMT4": ") lights solid green. The gateway will remain in AP mode for eight hours."
  },
  "desktop": {
    "status": {
      "power": "Power",
      "energy": "Energy",
      "battery": "Battery",
      "solarEquivalent": "Solar Equivalent",
      "dataUnavailable": "Data is not available"
    },
    "array": {
      "title": "Array",
      "totalProduced": "Total Produced",
      "totalConsumed": "Total Consumed",
      "lifetimeProduced": "Lifetime Produced",
      "lifetimeConsumed": "Lifetime Consumed",
      "status": "Status",
      "azimuth": "Azimuth",
      "tilt": "Tilt",
      "microinverter": "Microinverter"
    },
    "energy": {
      "totalEnergy": "Total Energy",
      "graphControls": "Graph Controls"
    },
    "header": {
      "switchToClassic": "Switch to classic view"
    },
    "footer": {
      "change": "Change",
      "changeSite": "Change Site",
      "copyRightsText": "©2008-%{currYear} Enphase Energy Inc. All rights reserved.",
      "privacyText": "Privacy",
      "termsText": "Terms",
      "weatherCompany": "The Weather Company",
      "weatherDataText": "Weather data provided by"
    }
  },
  "customPeriod": {
    "dialogLabel": "View Based On",
    "billingCycle": "Billing Cycle",
    "billingLabel": "Match the energy graph to your billing cycle",
    "billingLabelStatusPage": "Time period from any selected start date for the selected duration",
    "startDate": "Billing Start Date",
    "frequency": "Billing Frequency",
    "months": "Months",
    "days": "Days",
    "every": "Every",
    "customDate": "Custom Date Range",
    "customDateLabel": "Select a custom date span to view it on the energy graph",
    "customRange": "Please select a date range between 1 to 100 days"
  },
  "systemEstimator": {
    "heading": "System Estimator",
    "exitConfirmation": "Are you sure you want to close the Add Storage flow?",
    "resumeButton": "Resume",
    "systemAccess": "Get System Access",
    "statusAddStorage": "to avoid blackouts",
    "addStorageLeadInfo": "view status",
    "postLoginWoSiteTitle": "Meet the all-in-one solar and storage system",
    "videoCTABtn": "View storage",
    "addStorageTitle": "Get your Enphase system",
    "orderNowBtn": "Order Now"
  },
  "sgipIncentive": {
    "gotItButton": "Got It",
    "exitButton": "Exit",
    "dontExitButton": "Don’t Exit",
    "sgipPaymentNotDone": "Your SGIP application is incomplete. Do you wish to leave without completing your application?",
    "sgipPaymentDone": "You can come back anytime to check status of your SGIP application",
    "sgipApplyAlert": "SGIP incentives are applicable for systems installed in California only. If you already have a system activation in progress in California, please ask your installer to initiate the site creation process in their Enphase Application.",
    "sgipGetStorage": "Get a new Enphase storage system"
  },
  "gridBatteryChange": {
    "gridTag": "G",
    "batteryTag": "B",
    "gridChangeDesc": "Grid state changed to",
    "gridOn": "On Grid",
    "gridOff": "Off Grid",
    "batteryChangeDesc": "Battery profile changed to",
    "costSavings": "Cost Savings",
    "selfConsumption": "Self Consumption",
    "savingsMode": "Savings Mode",
    "backupOnly": "Backup only",
    "stormGuardDesc": "Storm Guard is",
    "alertIssued": " alert issued",
    "alertHasEnded": " alert has ended"
  },
  "liveVitalStats": (_liveVitalStats = {
    "normal": "Normal",
    "unknown": "Unknown",
    "undefined": "Undefined",
    "loads": "Load Control",
    "loadsInfoPart1": "The load are mapped to ",
    "loadsInfoPart2": "System controller Auxilliary contacts",
    "loadsInfoPart3": " by your installer. You can configure these loads in your ",
    "loadsInfoPart4": "System Settings",
    "powered": "Powered",
    "invalidState": "Invalid State",
    "viewMore": "View more",
    "viewLess": "View less",
    "ECA_BAT_IDLE": "Idle",
    "ECA_BAT_CHARGING": "Charging",
    "ECA_BAT_DISCHARGING": "Discharging",
    "MAX_ECA_BAT_STATE": "Unknown",
    "systemIsOnGrid": "System is On Grid",
    "systemIsOffGrid": "System is Off Grid",
    "infoIsOnGrid": "The system is operating in grid connected mode.",
    "infoIsOffGrid": "The system is operating in microgrid mode.",
    "wiredCANConn": "Wired CAN Connection",
    "infoWiredCAN": "The IQ System Controller communicates with the IQ Gateway via wired connection. The icon represents whether or not it is connected and communicating with the Gateway.",
    "infoIsOffGridAvailable": "The system is operating in microgrid mode. However the grid is available and you can choose to go On Grid anytime.",
    "voltageL1": {
      "val": "Voltage L1",
      "info": "The voltage between Line 1 (L1) and Neutral."
    },
    "voltageL2": {
      "val": "Voltage L2",
      "info": "The voltage between Line 2 (L2) and Neutral."
    },
    "voltageL3": {
      "val": "Voltage L3",
      "info": "The voltage between Line 3 (L3) and Neutral."
    },
    "voltage": {
      "val": "Voltage",
      "info": "The voltage between Line 1 (L1) and Neutral."
    },
    "frequency": {
      "val": "Frequency",
      "info": "The nominal Alternating Current (AC) Frequency."
    },
    "gridParameters": "Utility Grid Parameters",
    "auxiliaryContactsParameters": "Load Control",
    "infoauxiliaryContactsParam": "System controller has four auxiliary contacts for load control. Load name indicates that the corresponding contact is mapped to that load. For the contacts not mapped to any load, “Not in use” is displayed.",
    "infoGridParam": "Grid voltage and frequency are measured on the utility side of the Microgrid Interconnect Device (MID). When the grid is not available the grid voltage and frequency is 0.",
    "microgridParameters": "Microgrid Parameters",
    "infoMicrogridParam": "Microgrid voltage and frequency are measured on the load side of the Microgrid Interconnect Device (MID). If your MID is open then your system is in the Off Grid / Microgrid mode.",
    "generatorParameters": "Generator Parameters",
    "infoGeneratorParam": "Generator voltage and frequency are measured on the load side of the Generator Interconnect Device (GID). If your GID is closed then your system is in the Off Grid / Microgrid mode.",
    "infoEnpower": "IQ System Controller",
    "zigbeeSignal": "dBm",
    "commSignal": "Communication Signal",
    "infoZigbeeSignal": "Represents the strength of the 2.4 GHz wireless communication with gateway. More bars or a higher dBm value represents stronger signal strength.",
    "commStatus": "Communication Status",
    "infoCommSignal": "COMMUNICATION SIGNAL",
    "usbConnection": "USB Connection",
    "infoUsbSignal": "IQ System Controller communicates with IQ Gateway via USB connection. The icon represents whether or not the USB is connected and communicating with IQ Gateway.",
    "commStatusDesc": "IQ Battery communicates with IQ System Controller via wired connection. The icon represents whether or not IQ Battery is connected and communicating with IQ System Controller.",
    "ENCMN_STATE_UNKNOWN": {
      "val": "Unknown"
    },
    "ENCMN_STATE_MISSING": {
      "val": "2.4 GHz Communication Failure"
    },
    "ENCMN_STATE_DISCOVERED": {
      "val": "2.4 GHz pairing"
    },
    "ENCMN_STATE_CONNECTED": {
      "val": "2.4 GHz Pairing Complete"
    },
    "ENCMN_STATE_INV_DONE": {
      "val": "Finished retreiving device information"
    },
    "ENPWR_STATE_GRIDMODE_WAIT": {
      "val": "Waiting for batteries to acknowledge grid state"
    },
    "ENPWR_STATE_GRIDMODE_CONFIRM": {
      "val": "Commanding system controller to close EC1 relay"
    },
    "ENPWR_STATE_RELAY_CTRL_WAIT": {
      "val": "Unknown"
    },
    "ENPWR_STATE_GRID_PROFILE_UPD": {
      "val": "Starting grid profile update"
    },
    "ENPWR_STATE_GRID_PROFILE_SET": {
      "val": "Grid profile update in progress"
    },
    "ENPWR_STATE_GRID_PROFILE_END": {
      "val": "Grid profile update finished"
    },
    "ENPWR_STATE_RELAY_QUERY": {
      "val": "Fetching system controller relay states post initialization"
    },
    "ENPWR_STATE_OPER_SELECTOR": {
      "val": "Interpreting system controller relay states"
    },
    "ENPWR_STATE_OPER_NO_GRID": {
      "val": "System controller is Off Grid"
    },
    "ENPWR_STATE_OPER_OPEN_AC_PRESENT": {
      "val": "System controller is Off Grid. Grid is available"
    },
    "ENPWR_STATE_OPER_SYNC_READY": {
      "val": "Microgrid is synchronized to the grid. Ready to go On Grid"
    },
    "ENPWR_STATE_OPER_CLOSED": {
      "val": "System controller is On Grid"
    },
    "ENPWR_STATE_GOING_ON_GRID": {
      "val": "Commanding system controller to go On Grid"
    },
    "ENPWR_STATE_PREPARE_FOR_OFF_GRID": {
      "val": "Preparing to execute the user's command to go Off Grid"
    },
    "ENPWR_STATE_GOING_OFF_GRID": {
      "val": "Commanding system controller to go Off Grid"
    },
    "ENPWR_STATE_OPER_CLOSED_INIT": {
      "val": "System controller is On Grid. Discovering batteries."
    },
    "ENCMN_STATE_MAX": {
      "val": "Unknown"
    },
    "ENCMN_STATE_CONNECTED_NO_PCU": {
      "val": "No micros detected"
    },
    "ENCHG_STATE_READY": {
      "val": "Battery is Operational"
    },
    "ENCHG_STATE_GRIDMODE_UPD": {
      "val": "Sending grid mode to battery"
    },
    "ENCHG_STATE_BACKUP_SOC_UPD": {
      "val": "Updating the reserve State of Charge (SoC) limit on battery"
    },
    "ENCHG_STATE_GRID_PROFILE_UPD": {
      "val": "Starting grid profile update"
    },
    "ENCHG_STATE_GRID_PROFILE_SET": {
      "val": "Grid profile update in progress"
    },
    "ENCHG_STATE_GRID_PROFILE_END": {
      "val": "Grid profile update finished"
    },
    "ENCHG_STATE_INVENTORY": {
      "val": "Retreiving hardware and software information from the battery"
    },
    "ST_NOP": {
      "val": "Unknown"
    },
    "ENPWR_STATE_OPER_GEN_CLOSING_INIT": {
      "val": "System controller is Off Grid. Connecting to Generator."
    },
    "ENPWR_STATE_OPER_GEN_CLOSE": {
      "val": "System controller is Off Grid. Generator connected."
    },
    "ENPWR_STATE_OPER_GEN_OPENING_INIT": {
      "val": "System controller is Off Grid. Disconnecting Generator."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_EC1": {
      "val": "EC1 closed. Relay test complete."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_EC1": {
      "val": "EC1 open. Relay test in progress."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_GEN": {
      "val": "GEN relay closed. Relay test complete."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_GEN": {
      "val": "GEN relay open. Relay test in progress."
    },
    "default": {
      "val": "Unknown"
    },
    "controlState": "Control State",
    "CHECK_BUSES": {
      "val": "Checking Buses and Relays",
      "info": "The system controller was reset. Validating system parameters before transitioning to a different grid state."
    },
    "CYCLE_RELAYS": {
      "val": "Cycling Relays",
      "info": "Your system is cycling system controller relays to validate if the relay error conditions have cleared."
    },
    "GRID_CONNECT": {
      "val": "Connecting to Grid",
      "info": "Your system is connecting to the grid after the system controller was reset."
    },
    "EC1_EC2_CONNECT": {
      "val": "Batteries Connected. Connecting NFT",
      "info": "Your system is transitioning to microgrid. Batteries are connected. The Neutral Forming Transformer (NFT) is being connected."
    },
    "GRID_OP_WAIT_FOR_ENVOY": {
      "val": "On Grid. Connecting batteries",
      "info": "Your system is On Grid. Batteries are in the process of being connected."
    },
    "GRID_OP_FULL": {
      "val": "On Grid",
      "info": "Your system is operating in grid connected mode."
    },
    "MICROGRID_OK_NO_GENERATOR": {
      "val": "Off Grid",
      "info": "Your system is operating in microgrid mode."
    },
    "SYNC_TO_GRID": {
      "val": "Synchronizing to Grid",
      "info": "Your system is transitioning from microgrid to On Grid."
    },
    "MICROGRID_REGULATORY_SHUTDOWN": {
      "val": "Microgrid Failure",
      "info": "Microgrid collapsed due to overloading or a system error. The system will recover soon."
    },
    "MANUFACTURING_MODE": {
      "val": "Manufacturing Mode",
      "info": "Please contact customer support."
    },
    "RESET": {
      "val": "System controller Reset",
      "info": "Your system controller has reset. The system will recover soon."
    },
    "GRID_OP_OPEN_NFT": {
      "val": "On Grid. Opening NFT",
      "info": "Your system is On Grid. The Neutral Forming Transformer (NFT) is being disconnected."
    },
    "MANUAL_OVERRIDE": {
      "val": "Manual Override Activated",
      "info": "You have manually closed the Microgrid Interconnect Device (MID) to go On Grid. Please call customer support if you did not do this intentionally."
    },
    "RAPID_SHUTDOWN_STATE": {
      "val": "Rapid Shutdown State"
    },
    "UNKNOWN": {
      "val": "Unknown",
      "info": "Please contact customer support."
    },
    "ECA_RELAY_OPEN_AC_GRID_SYNCHED": {
      "val": "Synchronised and Connecting to Grid"
    },
    "infoControlState": "control states",
    "faults": "System controller error",
    "MID_FUSED": "Your system cannnot transition to microgrid mode as MID is stuck closed.",
    "EC1_FUSED": {
      "ES1": "Both IQ Battery L1 and L2 relays are stuck closed.",
      "ES2": {
        "NO_BATT-PV": "Both PV L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ8 PV L1 and L2 relays are stuck closed",
        "BATT-NO_PV": ""
      }
    },
    "EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery L1 and L2 relays are stuck closed"
      }
    },
    "EC1_EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Both IQ Battery and IQ8 PV, L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery and PV, L1 and L2 relays are stuck closed"
      }
    },
    "NFT_FUSED": "Neutral Forming Transformer (NFT) relays are stuck closed.",
    "NFT_OPEN": "Your system cannot transition to the microgrid mode as Neutral Forming Transformer (NFT) relays are stuck open.",
    "MID_OPEN": "Your system cannnot transition to grid connected mode as MID is stuck open.",
    "EC1_OPEN": {
      "ES1": "Your system cannot transition to the microgrid mode as one or both the IQ Battery L1 and L2 relays are stuck open.",
      "ES2": {
        "NO_BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the PV L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot use IQ8 PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot use PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode"
      }
    },
    "EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as one or both of the IQ Battery L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot reliably transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open. Only IQ8 PV will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open"
      }
    },
    "EC1_EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as IQ8 PV, L1 and L2 relays are stuck open",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as PV L1 and L2 relays are stuck open"
      }
    },
    "I2C_INIT": "Your system is not operational. The system controller's Automatic Transfer Switch (ATS) board has failed.",
    "ADC_INIT": "Your system is not operational. The system controller's Automatic Transfer Switch (ATS) board has failed.",
    "I2C_COMM": "Your system is not operational. The system controller's Automatic Transfer Switch (ATS) board has failed.",
    "NFT_TEMP": "Your system is not operational. The system controller's Neutral Forming Transformer (NFT) has exceeded temperature limits.",
    "ATS_TEMP": "Your system is not operational. The system controller's Automatic Transfer Switch (ATS) Board has exceeded temperature limits.",
    "E3_TEMP": "Your system is not operational. The system controller Board has exceeded temperature limits.",
    "CRC_MISMATCH": "Your system is not operational. The system controller Board has failed to initialize.",
    "V_IMBALANCE": "Your system cannot transition to the microgrid mode. A Voltage Imbalance between L1 and L2 has caused a trip.",
    "MANUAL_OVR": "Your system is in the grid connected mode due to system controller Manual Override.",
    "GEN_CONN_OPEN_NFT": 'Your system is connected to the Generator. The Neutral Forming Transformer (NFT) is being disconnected.',
    "MANUAL_BACKSTART": 'Your system is trying to blackstart in off grid mode.',
    "BACKSTART_FAILED": 'Your system could not blackstart in off grid mode. It will reattempt blackstart.',
    "GRID_TIED": 'Your system is in Grid Tied mode.',
    "MID": {
      "val": "MID",
      "info": "Microgrid Interconnect Device (MID) connects (when closed) or disconnects (when open) your home from the utility grid."
    },
    "DER_L1": {
      "val": "DER L1",
      "info": "Distributed Energy Resource (DER) relays DER L1 when closed connects your Encharges and PV on line 1 or 2 respectively to your Home."
    },
    "DER_L2": {
      "val": "DER L2"
    },
    "DER_L3": {
      "val": "DER L3"
    },
    "DER_1": {
      "val": "DER 1"
    },
    "DER_N": {
      "val": "DER N"
    },
    "SRT_L1_L2": {
      "val": "SRT L1_L2"
    },
    "SRT_L1_L3": {
      "val": "SRT L1_L2"
    },
    "EC1_L1": {
      "val": "EC1 L1",
      "info": "EC1 L1 and L2 relays when closed connects your batteries or IQ8 PV to your home loads. They operate line to line and do not have a neutral."
    },
    "ENCHARGE_L1L2": {
      "val": "IQ Battery L1, L2",
      "info": "IQ Battery L1 and L2 relays, when closed, connect your batteries to your home loads. They operate line to line and do not have a neutral."
    },
    "PV_L1L2": {
      "val": "PV L1, L2",
      "info": "PV L1 and L2 relays, when closed, connect your IQ8 PV to your home loads. They operate line to line and do not have a neutral."
    },
    "PV_L1_L2": {
      "val": "PV L1, L2",
      "info": "PV L1 and L2 relays, when closed, connect your IQ PV to your home loads. They operate line to line and do not have a neutral."
    },
    "DER_L1_L2": {
      "val": "DER L1, L2",
      "info": "DER L1 and L2 relays when closed connects your batteries or IQ PV to your home loads. They operate line to line and do not have a neutral."
    },
    "EC1_L2": {
      "val": "EC1 L2"
    },
    "ENCHARGE_L1": {
      "val": "IQ Battery L1"
    },
    "ENCHARGE_L2": {
      "val": "IQ Battery L2"
    },
    "PV_L1": {
      "val": "PV L1"
    },
    "PV_L2": {
      "val": "PV L2"
    },
    "NFT_L1": {
      "val": "NFT L1",
      "info": "NFT is the Neutral Forming Transformer. It ensures your system can operate in an Off Grid mode. The NFT L1 relay when closed powers on your NFT. The NFT N relay when closed connects the neutral from NFT to your home loads."
    },
    "NFT_N": {
      "val": "NFT N"
    },
    "GID_L1": {
      "val": "GID L1",
      "info": "GID L1 and L2 relays, when closed, connect your Generator to your home loads."
    },
    "GID_L2": {
      "val": "GID L2"
    },
    "NFT_L2": {
      "val": "NFT L2",
      "info": "NFT is the Neutral Forming Transformer. It ensures your system can operate in an Off Grid mode. The NFT L2 relay when closed powers on your NFT. The NFT N relay when closed connects the neutral from NFT to your home loads."
    },
    "DER1_L1": {
      "val": "DER1 L1",
      "info": "DER1 L1 and L2 relays when closed connects your batteries or IQ8 PV to your home loads. They operate line to line and do not have a neutral."
    },
    "DER1_L2": {
      "val": "DER1 L2"
    },
    "DER2_L1": {
      "val": "DER2 L1",
      "info": "DER2 L1 and L2 relays when closed connects your IQ8 PV to your home loads. They operate line to line and do not have a neutral."
    },
    "DER2_L2": {
      "val": "DER2 L2"
    },
    "dryContact": {
      "val": "NC1, NC2, NO1, NO2",
      "info": "These relays, when powered, connect your loads to the power source​.​"
    },
    "DER_L1_L2_L3_N": {
      "val": "DER L1, L2, L3, N",
      "info": "Distributed Energy Resource (DER) relays DER L1, DER L2, DER L3 and DER N when closed connects your IQ Battery and IQ Microinverter on line 1, 2, 3 and Neutral respectively to your Home."
    },
    "DER_L1_L2_N": {
      "val": "DER L1, L2, N",
      "info": "Distributed Energy Resource (DER) relays DER L1, DER L2 and DER N when closed connects your IQ Battery and IQ Microinverter on line 1, 2 and Neutral respectively to your Home."
    },
    "DER_1_N": {
      "val": "DER 1, N",
      "info": "Distributed Energy Resource (DER) relays DER L1 and DER N when closed connects your IQ Battery and IQ Microinverter on line and Neutral respectively to your Home"
    },
    "open": "Open",
    "closed": "Closed"
  }, _defineProperty(_liveVitalStats, "powered", "Powered"), _defineProperty(_liveVitalStats, "notPowered", "Not Powered"), _defineProperty(_liveVitalStats, "niu", "Not in use"), _defineProperty(_liveVitalStats, "infoEc1L1L2", "EC1 L1, L2"), _defineProperty(_liveVitalStats, "infoEnchargeL1L2", "IQ Battery L1, L2"), _defineProperty(_liveVitalStats, "infoPvL1L2", "PV L1, L2"), _defineProperty(_liveVitalStats, "infoNftL1N", "NFT L1, N"), _defineProperty(_liveVitalStats, "infoGidL1L2", "GID L1, L2"), _defineProperty(_liveVitalStats, "infoNftL2N", "NFT L2, N"), _defineProperty(_liveVitalStats, "infoDer1L1L2", "DER1 L1, L2"), _defineProperty(_liveVitalStats, "infoDer2L1L2", "DER2 L1, L2"), _defineProperty(_liveVitalStats, "enpowerDesc", "The difference between the Utility Grid and the Microgrid voltage and frequency is observed due to voltage drop across the Microgrid Interconnect Device (MID)."), _defineProperty(_liveVitalStats, "infoEnpwrDiagram", "This system controller block diagram is for illustration only."), _defineProperty(_liveVitalStats, "infoEnpowerRelays", "System controller Relays"), _defineProperty(_liveVitalStats, "bmuWarning", "BMU Warning"), _defineProperty(_liveVitalStats, "bmuL1Error", "BMU Level 1 Error"), _defineProperty(_liveVitalStats, "bmuL2Error", "BMU Level 2 Error"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_WARN_CODE", "Battery cell voltage maximum warning"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_WARN_CODE", "Battery cell voltage minimum warning"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_IMBAL_WARN_CODE", "Battery cell voltage imbalance warning"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_WARN_CODE", "Battery FET switch over voltage warning"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV1_CODE", "Battery cell voltage maximum error level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV1_CODE", "Battery cell voltage minimum error level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV1_CODE", "Battery cell temperature maximum error level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV1_CODE", "Battery cell temperature minimum error level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_DIS_OVER_CURRENT_ELV1_CODE", "Discharge over current error level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_LTC6811_NO_COMMS_ELV1_CODE", "No BMU Comms."), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_CURRENT_ELV1_CODE", "Field effect transistor current error level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FUSE_OPEN_ELV1_CODE", "Fuse open error level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_DRIVER_ELV1_CODE", "Field effect transistor driver error level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_SENSE_LINE_OPEN_ELV1_CODE", "Voltage Sense line open error level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_ELV1_CODE", "Field effect transistor over temperature error level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_THERMAL_LINE_OPEN_ELV1_CODE", "Thermal line open error level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_24V_ELV1_CODE", "Precharge 24V circuit error Level 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_VBAT_ELV1_CODE", "Precharge battery cell voltage error Level"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV2_CODE", "Battery Cell Voltage maximum error level 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV2_CODE", "Battery Cell Voltage minimum error level 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV2_CODE", "Battery Cell temperature maximum error level 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV2_CODE", "Battery Cell temperature minimum error level 2"), _defineProperty(_liveVitalStats, "gridMode", "Grid Mode"), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED", {
    "val": "Grid Tied",
    "info": "Battery is in the grid connected mode. In this temporary state it will not form a microgrid when the grid is unavailable.",
    "pcuInfo": "Microinverter is in the grid connected mode. It will not form a microgrid when the grid is unavailable."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ON_GRID", {
    "val": "On Grid",
    "info": "Battery is in the grid connected mode and is capable of forming a microgrid when it needs to.",
    "pcuInfo": "Microinverter is in the grid connected mode and is capable of forming a microgrid when it needs to."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_OFF_GRID", {
    "val": "Off Grid",
    "info": "Battery has formed a microgrid.",
    "pcuInfo": "Microinverter has formed a microgrid."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ISLANDING", {
    "val": "Island Detected",
    "info": "Battery has detected that the grid is unstable / not available. It is in the process of forming the microgrid.",
    "pcuInfo": "MIcroinverter has detected that the grid is unstable / not available. It is in the process of forming the microgrid."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED_BLACK_START", {
    "val": "Forming Microgrid",
    "info": "Battery has just restarted. It has detected that the utility grid is not available and is in the process of forming the microgrid. Reducing home load helps microgrid formation.",
    "pcuInfo": "Microinverter has just restarted. It has detected that the utility grid is not available and is in the process of forming the microgrid. Reducing home load helps microgrid formation."
  }), _defineProperty(_liveVitalStats, "gridModeUnknown", {
    "val": "Invalid",
    "info": "Invalid grid mode received for battery.",
    "pcuInfo": "Invalid grid mode received for microinverter."
  }), _defineProperty(_liveVitalStats, "infoGridModes", "grid modes"), _defineProperty(_liveVitalStats, "ledStatus", "LED Status"), _defineProperty(_liveVitalStats, "phase", "Phase"), _defineProperty(_liveVitalStats, "infoEncharge", "IQ Battery"), _defineProperty(_liveVitalStats, "infoAcb", "ACB"), _defineProperty(_liveVitalStats, "infoEnchargeDesc1", "In each battery there are %{pcuLength} IQ8X-BAT microinverters."), _defineProperty(_liveVitalStats, "infoEnchargeDesc2", "A positive microinverter power (kW) value indicates that the battery is discharging while a negative power (kW) value indicates that the battery is charging."), _defineProperty(_liveVitalStats, "infoPcuMicro", "IQ8X-BAT Microinverters"), _defineProperty(_liveVitalStats, "infoEnsemble3_0", "IQ8D-BAT Microinverters"), _defineProperty(_liveVitalStats, "infoEnsemble3_0_EnchargeDesc1", "In each battery there are %{pcuLength} IQ8D-BAT microinverters."), _defineProperty(_liveVitalStats, "pcu", "Micro"), _defineProperty(_liveVitalStats, "enph_oper_state", "State"), _defineProperty(_liveVitalStats, "EN_OP_ST_Idle", {
    "val": "Idle"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Starting", {
    "val": "Starting"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Discovery", {
    "val": "Discovery via Power Line Communcation (PLC) in progress"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Throttled", {
    "val": "Normal"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Mppt", {
    "val": "Normal (MPPT)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Bursting", {
    "val": "Normal (Bursting)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Constant_Vin", {
    "val": "Operating in Constant DC Voltage Mode"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Standby", {
    "val": "Normal (Standby)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Protection_Fault", {
    "val": "Shutdown (Protection Fault)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Grid_Fault", {
    "val": "Shutdown (Grid Fault)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Dcr", {
    "val": "Normal (DCR Check)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Unknown_state", {
    "val": "Unknown"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_DMIR_Init_Failed", {
    "val": "Firmware Fault"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Host_Shutoff", {
    "val": "Disabled (Host Shutoff)"
  }), _defineProperty(_liveVitalStats, "ac_power", "AC Power"), _defineProperty(_liveVitalStats, "signalStrength", "Signal Strength"), _defineProperty(_liveVitalStats, "commOk", "Comm Ok"), _defineProperty(_liveVitalStats, "noComm", "No Comm"), _defineProperty(_liveVitalStats, "Normal", {
    "val": "Normal"
  }), _defineProperty(_liveVitalStats, "Unknown", {
    "val": "Unknown"
  }), _defineProperty(_liveVitalStats, "pes", (_pes = {
    "voltage": "Voltage",
    "frequency": "Frequency",
    "current": "Current",
    "mode": "Mode",
    "status": "Status",
    "operatingMode": "Operating Mode",
    "systemControls": "System Controls",
    "builtInBattery": "Built-In Battery",
    "IQ8D_MicroInverters": "IQ8D-BAT Microinverters",
    "powerIn": "Power In",
    "powerOut": "Power Out",
    "idle": "Idle",
    "charging": "Charging",
    "normal": "Normal",
    "batteryFault": "Battery Fault",
    "PCUFault": "Pcu fault",
    "solarPvFault": "Solar PV fault",
    "powerOutFault": "Power out fault",
    "powerInFault": "Power in fault",
    "grid_relay": "Grid Relay",
    "pcu_relay": "PCU Relay",
    "ac_loads": "AC Loads",
    "dc_loads": "DC Loads",
    "powered": "Powered"
  }, _defineProperty(_pes, "idle", "Idle"), _defineProperty(_pes, "disabled", "Disabled"), _defineProperty(_pes, "batteryState", "Battery is "), _defineProperty(_pes, "144cellBattery", "144 Cell Battery"), _defineProperty(_pes, "powerIn", "Power In"), _defineProperty(_pes, "average", "Average"), _defineProperty(_pes, "min", "Min"), _defineProperty(_pes, "max", "Max"), _defineProperty(_pes, "cellVoltage", "Cell Voltage"), _defineProperty(_pes, "cellTemp", "Cell Temperature"), _defineProperty(_pes, "pcuMode", "PCU Mode"), _defineProperty(_pes, "micro", "Micro"), _defineProperty(_pes, "acPower", "Ac Power"), _defineProperty(_pes, "dcPower", "DC Power"), _defineProperty(_pes, "state", "State"), _defineProperty(_pes, "grid", "Grid"), _defineProperty(_pes, "solar", "Solar"), _defineProperty(_pes, "auxIn", "Aux In"), _defineProperty(_pes, "acOut", "AC Out"), _defineProperty(_pes, "usbOut", "USB Out"), _defineProperty(_pes, "auxOut", "Aux Out"), _defineProperty(_pes, "coolingFan", "Cooling Fan"), _defineProperty(_pes, "devicelight", "Device Light"), _defineProperty(_pes, "OC", "OC"), _defineProperty(_pes, "OT", "OT"), _defineProperty(_pes, "OV", "OV"), _defineProperty(_pes, "UT", "UT"), _defineProperty(_pes, "UV", "UV"), _defineProperty(_pes, "UC", "UC"), _defineProperty(_pes, "coldIdle", "Cold Idle"), _defineProperty(_pes, "hotIdle", "Hot Idle"), _defineProperty(_pes, "hotCharging", "Hot Charging"), _defineProperty(_pes, "hotDisCharging", "Hot Discharging"), _defineProperty(_pes, "cellImbalance", "Cell Imbalance"), _defineProperty(_pes, "unknown", "unknown"), _defineProperty(_pes, "powerMode", "Power Mode"), _defineProperty(_pes, "SYSTEM_OFF", "Off"), _defineProperty(_pes, "POWER_SAVE", "Save"), _defineProperty(_pes, "SYSTEM_ON", "On"), _defineProperty(_pes, "systemControlInfo", "The difference between the Utility Grid and the Microgrid voltage and frequency is observed due to voltage drop across the grid relay."), _pes)), _liveVitalStats),
  "ledStatus": {
    "title": "LED Status",
    "code": {
      "-1": "Unknown",
      "0": "Error Needs Service",
      "1": "BMU L1 Error",
      "2": "High Temperature",
      "3": "DC Switch OFF",
      "4": "No Comms with gateway",
      "5": "Comms Connected but not Challenged",
      "6": "Comms connected and challenged",
      "7": "Upgrade Fail",
      "8": "BC Update in Progress",
      "9": "BMU Update in Progress",
      "10": "PCU update in progress",
      "11": "Sleep mode",
      "12": "Charging",
      "13": "Discharging",
      "14": "Battery capacity is between: 75-100%",
      "15": "Battery capacity is between: 50-75%",
      "16": "Battery capacity is between: 25-50%",
      "17": "Battery capacity is between: 0-25%",
      "18": "System UP"
    },
    "info": {
      "safetyIssue": "None of the LED states presents a safety issue",
      "title": {
        "flashingRed": "Flashing Red",
        "flashingYellow": "Flashing Yellow",
        "softPulseYellow": "Soft Pulse Yellow",
        "softPulseBlue": "Soft Pulse Blue",
        "softPulseGreen": "Soft Pulse Green",
        "solidRed": "Solid Red",
        "solidYellow": "Solid Yellow",
        "solidBlueOrGreen": "Solid Blue or Green",
        "ledOff": "Off"
      },
      "desc": {
        "flashingRed": "Update failed or the battery is in error state. Contact your Installer or Enphase support.",
        "flashingYellow": "Update in progress.",
        "softPulseYellow": "Sleep mode activated.",
        "softPulseBlue": "Discharging.",
        "softPulseGreen": "Charging.",
        "solidRed": "Starting up.",
        "solidYellow": "Not operating due to high temperature. See \"IQ Battery Troubleshooting\" A for more details.",
        "solidBlueOrGreen": "Idle. Color transitions between blue and green as state of charge changes. Charge status is updated on Enphase app. See \"IQ Battery Troubleshooting\" C for more details.",
        "ledOff": "Not operating. See \"IQ Battery Troubleshooting\" B for more details."
      }
    },
    "enpowerRow": {
      "code": {
        "-1": "Unknown",
        "0": "System Controller Error(On-Grid)",
        "1": "System Controller Error (Off-Grid)",
        "2": "System Controller is in rapid shutdown/manual override mode",
        "3": "System Controller Off-Grid; DERs disconnected",
        "4": "System Controller operational, cannot detect any IQ Batteries over CAN (On-Grid)",
        "5": "System Controller operational, cannot detect at least one IQ Battery over CAN (On-Grid)",
        "6": "System Controller operational, cannot detect at least one IQ Battery over CAN (Off-Grid)",
        "7": "System Controller Off-Grid; Performing SoC Recovery",
        "8": "System Controller is synchronizing to grid",
        "9": "System Controller FW upgrade (On-Grid)",
        "10": "System Controller FW upgrade(Off-Grid)",
        "11": "System Controller ON, Booting",
        "12": "System Controller ON and On-Grid",
        "13": "System Controller ON and Off-Grid",
        "14": "System Controller OFF"
      }
    }
  },
  "updatePending": {
    "title": "Data upload in progress",
    "content": "Your gateway is uploading your system data to Enphase cloud. This happens when the gateway has been offline for some time. Typically it takes 1 hour for every day of the gateway being offline. Don’t worry, the message will go away once all data is uploaded.",
    "envoyDataTitle": "Data Uploading",
    "envoyDataContent": "Your system recently reconnected to the internet and needs some time to upload your data. It can take up to an hour for each day it was offline."
  },
  "bkpConfig": {
    "title": "Backup Configurations",
    "0": "Not selected",
    "1": "Partial Home Backup",
    "2": "Whole Home Backup"
  },
  "set": "Set",
  "change": "Change",
  "allTopics": "All Topics",
  "referFriends": {
    "title": "Refer friends",
    "subTitle_1": "to give ",
    "subTitle_2": " and get ",
    "description_1": "Both you and your friend will be eligible to receive ",
    "description_2": " gift card each after your friend purchases and activates a new Enphase solar or storage system using the link below.",
    "description_3": " gift card each after your friend purchases and activates a new Enphase solar system using the link below.",
    "urlHeading": "Your referral URL",
    "shareButton": "Share your referral link",
    "copyButton": "Copy your referral link",
    "termsConditions": "Terms and conditions",
    "applyTerms": "apply.",
    "toastMessage": "Referral link copied to your clipboard",
    "shareMessage_1": "Hey! Did you know my house is solar powered? If you were thinking of going solar, now is the time. I have an exclusive referral link that you can use to receive ",
    "shareMessage_2": " when you activate a new Enphase solar system.",
    "shareMessageAU_1": "Hey! Getting Enphase solar for my home is one the best investments I've made so I'm sharing the sunshine. If you’re considering ways to lower your electricity bills and protect your pocket, I have a referral link that you can use to receive ",
    "shareMessageAU_2": " when you go solar with Enphase. Check it out:",
    "tncTitle": "Enphase Referral Program Terms and Conditions:",
    "important_title": "Important",
    "important_subtitle": "You and your friend will only be eligible for the voucher if:",
    "important_1": "There is a gap of at least 15 days between completed registration and installation.",
    "important_2": "The email address with which the referral is received or registered is used to activate the system, once installed",
    "tnc": {
      "1": "Limit of 30 referrals per customer.",
      "2": "Referrals must use the link you share and provide their contact information to Enphase through the designated Enphase website on or before December 31, 2022.",
      "3": "If Enphase or its installers already have the email ID provided by the Referral, your Referral will not be eligible to participate in this Referral Program.",
      "4": "You and your Referral will be eligible to receive the Gift Cards only if your Referral purchases, installs, and completes their Enphase product activation within 2 years of Enphase’s receipt of the Referral’s information on the Enphase site.",
      "5": "After receiving notice from Enphase that you and your Referral are eligible to receive the Gift Card, you must claim the Gift Card within 90 days of receiving such notice.",
      "6_One": "If ",
      "6_Two": " Gift Cards are not available, Enphase may substitute another prize of equal or greater value.",
      "7": "The Gift Card amount selected reflects an estimate of the value of the referral vis-à-vis marketing expenditures saved on new customer recruitment.",
      "8": "If you or your Referral wish to withdraw from the Referral Program or from receiving the Gift Card reward, please contact Enphase",
      "9": "Enphase will not be responsible for garbled, incorrect, incomplete or delayed submissions, nor will Enphase be responsible for typographical errors, problems uploading or downloading the Referral information, or for any other technical malfunctions of networks, the internet, electronic equipment or websites.",
      "10": "Enphase reserves the right to modify, suspend or terminate this Referral Program without notice.",
      "11": "This Referral Program is void where prohibited.",
      "12": "In order for Enphase to attribute a referral, the unique link must be used by both you and your referral.",
      "13": "There needs to be a gap of at least 15 days between completed registration and installation.",
      "14": "The email address with which the referral is received or registered needs to be used to activate the system, once installed."
    }
  },
  "contactPVMaintainer": "Contact Solar maintainer",
  "contactStorageMaintainer": "Contact storage maintainer",
  "pvInstallerDetails": "Solar installer details",
  "storageInstallerDetails": "Storage installer details",
  "customerSupport": "Customer Support",
  "soFarToday": "So far today,",
  "forSelectedPeriod": "For the selected period,",
  "energyIndependence": {
    "title": "Energy Independence",
    "subTitle": "Measures your independence from the utility grid",
    "formulaText": "Energy Independence Calculation:",
    "formula": "[1-(Imported/Consumed)] * 100%",
    "formulaForGenerator": "[1 - {(Grid Imported + Generator Imported) / Consumed}] * 100%",
    "desc1": "Energy Independence is a measure of energy self-sufficiency. This means you are able to personally provide for all of your own energy demand.",
    "unknown": "it is unknown as your system hasn’t reported any consumption data.",
    "0": "all of your energy consumption is supplied by an external source such as utility grid. This means your Energy Independence score for %{periodValue} %{eiValue}%.",
    "100": "none of your energy consumption is supplied by an external source such as utility grid. This means your Energy Independence score for %{periodValue} %{eiValue}%.",
    "value": "%{geValue}% of your energy consumption is supplied by an external source such as utility grid. This means your Energy Independence score for %{periodValue} %{eiValue}%.",
    "forTodayPeriod": "today is",
    "forSelectedPeriod": "the selected period is",
    "addStorageTitle": "Add Storage",
    "addStorage": "to increase your Energy Independence.",
    "addStorageTitleWB": "Adding Solar or Storage",
    "addStorageWB": "increases your Energy Independence.",
    "clarify": "Energy Independence does not include energy exported and should not be mistaken with Net Metering (or Net Energy), which is the difference between imported and exported energy."
  },
  "backupHistory": {
    "backupEvents": "Total Backup Events"
  },
  "eventHistory": {
    "totalEvents": "Total Events",
    "events": "Item/Event",
    "deviceImpacted": "Device Impacted",
    "recommendedAction": "Recommended Action",
    "noBackupHistoryFound": "No backup history found",
    "eventStatus": "Event status"
  },
  "siteActivationStage": {
    "title": " has initiated activation of your Enphase system, ",
    "learnToUse": "Learn how you can use Enphase app to monitor your new Enphase system.​"
  },
  "sfdcChatBot": {
    "exitConfirmation": "Are you sure you want to exit from Chat with us?",
    "sfdcChatSubject": "Chat from Enphase app",
    "offlineSupport": "Unfortunately our agents are offline. Please leave us a message."
  },
  "pushN": {
    "ok": "Ok, go there",
    "stay": "Stay here",
    "permMsg": "You have received a notification for %{siteName} site. Change to this site to view the notification."
  },
  "tariffEditor": {
    "autofillChooseModeFAQ": "Which mode should I choose?",
    "autofillRatePlanExistFAQ": "Why isn't my utility or rate listed?",
    "autofillRatePlanMatchFAQ": "Why doesn't my rate look the same as on my electric bill?",
    "autofillTariffNote": "In case of difficulty in finding Tariff Name/Code, kindly contact your Utility Provider for details.",
    "whtBaslineElecRate": "What is your baseline electricity payout rate?",
    "doElecPayRateVaryWeekends": "Does your electricity payout rate vary on weekends?",
    "doElecPayRateVarySeasonaly": "Does your electricity payout rate vary seasonally?",
    "elecPayGoesUpWithUsage": "Your electricity payout rate goes up as your usage increase?",
    "pRatePeakOffPecakChanges": "Your electricity payout rate has peak and off-peak changes?",
    "ratePerUnitOfSolar": "What is your payout rate per unit of solar energy generated?",
    "payOutRate": "Payout Rate",
    "tarifeditorConstants1": "Electricity Rate Structure ",
    "tarifeditorConstants2": "Converts energy data into equivalent currency rates ",
    "tarifeditorConstants3": "View/Edit the electricity rate structure of your utility ",
    "tarifeditorConstants4": "You can check for electricity import rate information in your utility bill under the section highlighting the details of your electric charges. ",
    "tarifeditorConstants5": "Add Electricity Import Rate ",
    "tarifeditorConstants6": "Set the rate structure at which you get charged by your utility for importing electricity from the grid. ",
    "tarifeditorConstants7": "Note ",
    "tarifeditorConstants8": "The electricity rate information is used by the gateway to determine the best battery charge and discharge schedule when your battery profile is set as 'Savings Mode'. Changing this information will change the system's behavior.",
    "tarifeditorConstants9": "Electricity rate structure is not added ",
    "tarifeditorConstants10": "Add Electricity Import Rate ",
    "tarifeditorConstants11": "Select a mode to add your details ",
    "tarifeditorConstants12": "Autofill ",
    "tarifeditorConstants13": "Import your electricity rate structure using the information from your utility. ",
    "tarifeditorConstants14": "Manual ",
    "tarifeditorConstants15": "Manually enter the details of your utility's electricity rate structure. ",
    "tarifeditorConstants16": "Zipcode ",
    "tarifeditorConstants17": "Utility Name ",
    "tarifeditorConstants18": "Tariff Name / Code ",
    "tarifeditorConstants19": "Electricity Import Rate Details ",
    "tarifeditorConstants20": "Flat Rate ",
    "tarifeditorConstants21": "Tiered ",
    "tarifeditorConstants22": "Time of Use ",
    "tarifeditorConstants23": "Fixed Rate ",
    "tarifeditorConstants24": "Disclaimer ",
    "tarifeditorConstants25": "The reported electric rates are bundled changes that includes consumption based rate components only. Fixed charges adjustments credits incentives region specific and taxes are not considered. ",
    "tarifeditorConstants26": "Confirm & Save ",
    "tarifeditorConstants27": "Electricity Rate Name ",
    "tarifeditorConstants28": "Baseline Electricity Rate ",
    "tarifeditorConstants29": "Are you sure you want to reset the details ? ",
    "tarifeditorConstants30": "Your electricity rate has peak and off-peak charges? ",
    "tarifeditorConstants31": "Your electricity rate goes up as your usage increase? ",
    "tarifeditorConstants32": "Fixed Electricity rate that does not vary. ",
    "tarifeditorConstants33": "Electricity rate goes up as usage increses. ",
    "tarifeditorConstants34": "Does your electricity rate vary seasonally? ",
    "tarifeditorConstants35": "Does your electricity rate vary on weekends? ",
    "tarifeditorConstants36": "What is your baseline electricity rate? ",
    "tarifeditorConstants37": "Fixed Electricity rate that does not vary. ",
    "tarifeditorConstants38": "Electricity rate structure varies only seasonally. ",
    "tarifeditorConstants39": "Electricity rate structure varies on weekends. ",
    "tarifeditorConstants40": "Electricity rate structure varies seasonally and on weekends. ",
    "tarifeditorConstants41": "Electricity rate goes up as usage increases. ",
    "tarifeditorConstants42": "Baseline electricity rate : ",
    "tarifeditorConstants43": "Electricity rate structure varies only seasonally. ",
    "tarifeditorConstants44": "Electricity rate has peak and off-peak charges. ",
    "tarifeditorConstants45": "Electricity rate structure varies only on weekends. ",
    "tarifeditorConstants46": "Add Electricity Export Rate ",
    "tarifeditorConstants47": "Add the rate structure at which you get paid for exporting your solar generated electricity to the grid. ",
    "tarifeditorConstants48": "Select your electricity export plan ",
    "tarifeditorConstants49": "How to select your electricity export plan ",
    "tarifeditorConstants50": "You can check for this information in your utility bill under the section highlighting your credits and adjustments. ",
    "tarifeditorConstants51": "NEM (Net Energy Metering) ",
    "tarifeditorConstants52": "Check this if you have a net meter configuration at your home. <b style='font-weight: bold;'>Your electricity import rate will be copied as your electricity export rate.</b> ",
    "tarifeditorConstants53": "Net FIT (Net Feed-In Tariff) ",
    "tarifeditorConstants54": "Check this if you only get paid for solar energy that goes back into the grid from your house. ",
    "tarifeditorConstants55": "Gross FIT (Gross Feed-In Tariff) ",
    "tarifeditorConstants56": "Check this if you get paid for every unit of electricity generated by your solar panels. ",
    "tarifeditorConstants57": "Other ",
    "tarifeditorConstants58": "Check this if you are on any other plan. ",
    "tarifeditorConstants59": "Electricity export rate details ",
    "tarifeditorConstants60": "Electricity Payout Rate Structure ",
    "tarifeditorConstants61": "Export Plan ",
    "tarifeditorConstants62": "Edit Electricity Export Rate ",
    "tarifeditorConstants63": "Your FIT plan pays you at a fixed price per unit of solar energy exported? ",
    "tarifeditorConstants64": "Time varying Rate ",
    "tarifeditorConstants65": "Electricity payout rate has peak and off-peak charges ",
    "tarifeditorConstants66": "Fixed Electricity payout rate that does not vary ",
    "tec67": "Baseline electricity payout rate",
    "tec68": "Rate Name",
    "tec69": "We regret to inform you that your tariff structure is not supported for autofill. We are working to fix this. In the meantime, you can set your tariff using the manual flow.",
    "tec70": "Couldn’t fetch the utility name for your zip code. Please set the tariff manually.",
    "tec71": "Sorry, we couldn't fetch the Tariff details.",
    "tec72": "Select Utility Name",
    "tec73": "Search",
    "tec74": "Tariff Name / Code",
    "tec75": "Select Tariff Name / Code",
    "tec76": "Set Tariff Manually",
    "tec77": "Try Again",
    "tec78": "Select charging time",
    "tec79": "Charge batteries from the grid",
    "from": "From",
    "to": "To",
    "tec80": "Charge battery from grid updated successfully",
    "try_again": "Please try again.",
    "tec81": "Rate your experience",
    "tec82": "Was this data helpful and accurate?",
    "tec83": "Not Likely",
    "tec84": "Most Likely",
    "tec85": "For any questions or clarifications, please write to us.",
    "tec86": "You don’t want your batteries to be charged from the Grid?",
    "tec87": "Thank you for your valuable feedback",
    "talc": "Please try again later",
    "tec88": "How is your experience with tariff editor?",
    "tec89": "Note",
    "tec90": "Copy from Buying Tariff",
    "tec91": "Copy your tariff setting from set buying tariff",
    "tec92": "Electricity Export Rate",
    "tec93": "Electricity Import Rate",
    "tec94": "The electricity rate shown here is bundled according to the rate components shown below.",
    "tec95": "Answer the questions below to set your tariff type.",
    "tec96": "Invalid Time Range",
    "tec97": "%{time1} - %{time2} is already selected",
    "peak": "Peak",
    "aPeak": "Add Peak",
    "aSeason": "Add Season",
    "season": "Season",
    "eSeason": "Edit Season",
    "tec98": "Invalid entry. The value should be greater than Tier %{index}",
    "tec99": "An error occurred, please try again later",
    "tec100": "Electricity payout rate goes up as usage increases.",
    "tec101": "Time-varying Rate",
    "tier": "Tier",
    "offPeak": "Off-Peak",
    "tec102": "Edit Electricity Import Rate",
    "tec103": "manual configuration",
    "tec104": "autofill tariff",
    "tec105": "Select a mode",
    "tec106": "Select a mode to edit your details",
    "tec107": "select tariff name",
    "tec108": "The electricity rate information is used by the gateway to determine the best battery charge and discharge schedule. Changing this information will change the system's behaviour.",
    "tec109": "The electricity rate information is used to calculate your energy savings over time, and give you personalised recommendations to help you save your energy cost.",
    "tec110": "What is your payout rate per unit of solar energy exported?",
    "tec111": "Electricity Import Rate added",
    "tec112": "Electricity Import Rate updated",
    "tec113": "Electricity Import Rate reset",
    "tec114": "Electricity Export Rate added",
    "tec115": "Electricity Export Rate updated",
    "tec116": "Electricity Export Rate reset",
    "rate": "Rate",
    "tec117": "Fixed Payout Rate",
    "tec118": "Other (Tiered )",
    "tec119": "Other (Time of Use )",
    "tec120": "Other (Flat Rate )",
    "tec121": "Gross FIT",
    "tec122": "Net FIT (Time-varying Rate)",
    "tec123": 'Net FIT (Flat Rate )',
    "tec124": "NEM",
    "tec125": "Fixed Electricity rate that does not vary. Electricity rate structure varies only seasonally.",
    "tec126": "Fixed Electricity rate that does not vary. Electricity rate structure varies only on weekends.",
    "tec127": "Fixed Electricity rate that does not vary. Electricity rate structure varies seasonally and on weekends.",
    "tec128": "Fixed Electricity payout rate that does not vary. Electricity rate structure varies only seasonally.",
    "tec129": "Fixed Electricity payout rate that does not vary. Electricity rate structure varies only on weekends.",
    "tec130": "Fixed Electricity payout rate that does not vary. Electricity rate structure varies seasonally and on weekends.",
    "tec131": "Electricity rate has peak and off-peak charges. Electricity rate structure varies only seasonally.",
    "tec132": "Electricity rate has peak and off-peak charges. Electricity rate structure varies only on weekends.",
    "tec133": "Electricity rate has peak and off-peak charges. Electricity rate structure varies seasonally and on weekends.",
    "tec134": "Electricity payout rate has peak and off-peak charges. Electricity rate structure varies only seasonally.",
    "tec135": "Electricity payout rate has peak and off-peak charges. Electricity rate structure varies only on weekends.",
    "tec136": "Electricity payout rate has peak and off-peak charges. Electricity rate structure varies seasonally and on weekends.",
    "tec137": "Electricity rate goes up as usage increases. Electricity rate structure varies only seasonally.",
    "tec138": "Electricity payout rate goes up as usage increases. Electricity rate structure varies only seasonally.",
    "emptystring": "",
    "tec139": "ToU",
    "tec140": "Show Historic Rates",
    "tec141": "Electricity Import Rate added successfully",
    "tec142": "Please rate your experience of adding Electricity Rate",
    "tec143": "Dissatisfied",
    "tec144": "Satisfied",
    "tec145": "Skip",
    "tedc0": "Demand Charge",
    "tedc1": "All Day Demand Charge (24 hour)",
    "tedc2": "Your electricity rate includes demand charge component added monthly in your electricity bill.",
    "tedc3": "Your electricity rate includes demand charge component. During peak hours, the max consumption for any %{time}-minute interval during the month will be charged as per following details",
    "tedc4": "%{time}-min Max. Consumption",
    "tedc5": "Select an Electricity Rate Structure",
    "tet1": "Tell me about adding electricity rate",
    "tet2": "In some areas, the cost of electricity shifts up and down throughout the day or based on how much you use. We use your electricity rate to plan the best battery charge and discharge schedule when its profile is set to Savings Mode.",
    "tet3": "Get started",
    "tet4": "Tap 'Add Electricity Import Rate'.",
    "tet5": "Enter your information",
    "tet6": "Use Autofill or Manual to enter your rate details. You may need a current electric bill if you enter your rate manually.",
    "tet7": "Autofill",
    "tet8": "Select your Utility and Plan Name or Code from the drop down menus. The app will automatically look up your electricity import rate.",
    "tet9": "Manual",
    "tet10": "Enter details in each field — you may need to refer to a current electric bill to gather all the needed information.",
    "tet11": "Add Electricity Export Rate",
    "tet12": "If you get a credit for sending electricity back to the grid, add your electricity export rate next. Tap 'Add Electricity Export Rate' to get started — you'll have the same options to enter your information via autofill or manually.",
    "tet13": "How we determine and use your electricity rate",
    "undefined": "Other (Tiered)",
    "timeDiffError": "Start and End time should have a minimum difference of 15 mins",
    "periodOverlapError": "This period is overlapping with one of the other periods",
    "peakConflictError": "Peak rate should be higher than the Off-Peak rate",
    "isTimeValid": 'The start time must be earlier than the end time'
  },
  "appliance": {
    "info": "To keep your home powered for prolonged periods of time during grid outage, we recommend that you minimize and manage your energy consumption",
    "desc": "Turn off non-critical home loads to increase battery life.",
    "descSystem2_0AndEncharge": "Best practices during a grid outage.",
    "largeAppliances": "Large Appliances",
    "useSparingly": "Use sparingly",
    "essentialAppliances": "Essential Appliances",
    "useNormally": "Use normally",
    "airConditioner": "Air Conditioner",
    "dishwasher": "Dishwasher",
    "poolPump": "Pool Pump",
    "washingMachine": "Washing Machine",
    "electricVehicle": "Electric Vehicle",
    "electricDryer": "Electric Dryer",
    "lights": "Light(s)",
    "laptop": "Laptop",
    "television": "Television",
    "refrigerator": "Refrigerator",
    "wifiRouter": "Wi-Fi Router",
    "microwave": "Microwave"
  },
  "rootedAlert": {
    "exitBtn": "Exit",
    "proceedBtn": "Proceed",
    "agreeBtn": "I Agree",
    "warningLabel": "WARNING!",
    "warningTextInitial": "Your device appears to be rooted. Rooting compromises the default security protection and makes the data stored on your device vulnerable. It is not recommended to run Enphase app on rooted device.",
    "warningTextFinal": "By proceeding further, I understand and agree that Enphase shall not be responsible for any malfunction or consequences of running Enphase application on this rooted device."
  },
  "generator": {
    "exerciseModeOverlap1": "Exercise time is overlapping with your Quiet Time",
    "exerciseModeOverlap2": "to",
    "exerciseModeOverlap3": "Do you want to continue ?",
    "dayInWeek": "Day in week",
    "time": "Time",
    "duration": "Duration",
    "frequency": "Frequency",
    "save": "Save",
    "edit": "EDIT",
    "cancelRequest": "Cancel Request",
    "activate": "Activate",
    "okayText": "OK, Got it!",
    "batteryUnavailable": "<span>Your system does not have a battery.<a href='https://estimator.enphaseenergy.com/login' target='_blank'> Add Storage</a> to control your %{device} based on battery charge. </span>",
    "suspendedStateText": "Your generator is currently disabled. Enable your generator by using the toggle button at the top of the screen to activate the generator profile.",
    "suspendedModalHeading": "Your Generator will always be turned off in this state.",
    "suspendedModalHeading_1": "Your generator will be turned on based on the selected profile.",
    "suspendedModalSubheading": " Do you want to continue?",
    "infoHeadng": "Generator",
    "infoSubheading": "When %{enabled}, you can choose one of the two profiles to start your generator. %{nl} When %{disabled} or when your system is On Grid, the generator will always be turned off.",
    "advancedSettings": "Advanced Settings",
    "pendingRequest": "Pending Request",
    "disabled": "Disabled",
    "disable": "Disable",
    "enabled": "Enabled",
    "waiting": "Waiting for Information",
    "active": "Active",
    "deviceDetails": "Select a profile to start your generator",
    "autoStart": "Automatic​",
    "autoStartSubheading": "Turn on when Off Grid",
    "batteryOptimizationSubheading": "Turn on based on battery charge",
    "batteryChargeThreshold": "Battery Charge Threshold",
    "lowerLimit": "Start Limit: ",
    "start": "Start: ",
    "stop": "Stop: ",
    "upperLimit": "Stop Limit: ",
    "addQuietTime": "Set Quiet Time",
    "quietTime": "Quiet Time",
    "quietTimeToggle": "Use if you don’t want to turn on your generator during this time. When battery reaches critical limit, generator will be turned on irrespective of quiet time.",
    "startTime": "Start Time: ",
    "endTime": "End Time: ",
    "criticalChargeSettings": "Critical Charge Settings:",
    "generatorLoadingToast": "Generator status confirmation is taking longer than expected. Please check back later.",
    "exerciseMode": "Exercise Settings",
    "exerciseModeSubheading": "This is used to run the generator automatically on a regular interval to keep it in good working condition.",
    "batteryOptimization": "Eco-friendly",
    "activateBatteryProfile": "You have selected the Autostart profile. Please activate the “Start Based on Battery Level”  profile to add Quiet Time",
    "manualMode": "Manual Mode",
    "manualModeDescription": "Your generator is currently operating in manual mode. Please change your generator mode to auto or contact your installer.",
    "generatorStartLimit": "Start Limit cannot be below 10%",
    "generatorStartStopLimit": "Start Limit and Stop Limit should have a minimum difference of 5%",
    "generatorLimitDescription": "Use this to avoid turning your generator on during specific time periods. Generator is turned on when battery charge goes below critical charge limit.",
    "generatorQuietTime": "Quiet time",
    "generatorNormalTime": "Normal time",
    "generatorEnableGenerator": "Enable Generator",
    "generatorDisableGenerator": "Disable Generator",
    "automatic": "Automatic",
    "ecoFriendly": "Eco-friendly"
  },
  "sgipStatic": {
    "applyForIncentive": "Apply for Sgip incentive",
    "subheadingSgip": "System Owners in California, who are planning or have purchased an Enphase Battery for their home can apply for SGIP",
    "applyNow": "Apply Now",
    "learnMore": "Learn More",
    "serviceFee": "* Service fee may apply",
    "enphaseRepresentative": "* You may be contacted by an Enphase representative via call/email",
    "documentsRequired": "Following documents are required to apply for SGIP Incentive:",
    "documentHeading1": "1. Latest Utility Bills (At least one bill from the last 3 months)",
    "documentHeading2": "2. Contract Document",
    "additionalInfo": "* Additional documents may be required before final incentive payout"
  },
  "activationProgress": {
    "systemActivationInProgress": "Your system activation is in progress",
    "completed": "Completed",
    "viewDetails": "View Details",
    "activationCompleted": "Activation is 100% Complete",
    "activationInProgress": "Activation in Progress",
    "devices": "Devices",
    "status": "Status",
    "envoy": "Gateway",
    "encharge": "Battery",
    "enpower": "System Controller",
    "pvProduction": "PV Production",
    "cosumptionCT": "Consumption CT",
    "systemOperational": "System Operational",
    "reporting": "Reporting",
    "notReporting": "Not Reporting",
    "enabled": "Enabled",
    "notEnabled": "Not Enabled",
    "producing": "Producing",
    "verified": "Verified",
    "notVerified": "Not Verified",
    "featuresNowEnable": "Following features are now enabled.",
    "featuresWillBeEnabled": "Following features will be enabled once your system activation is complete:",
    "consumptionMonitoring": "Consumption Monitoring",
    "liveStatus": "Live Status",
    "stormGuard": "Storm Guard",
    "batteryProfileSetting": "Battery Profile Settings",
    "gridControl": "Grid Control"
  },
  "prodIssue_faq_1": "Why is one of my panels producing less than the others?",
  "prodIssue_faq_2": "It is common for panels on the same roof to vary in energy generation. Many factors can cause these variations, such as panel direction, shading from chimneys or trees, and other obstructions.",
  "accountNew": {
    "account": {
      "title": "Your Information",
      "title_alternate": "Personal Information",
      "save_changes": "Save Changes",
      "name_label": "Name:",
      "phone_label": "Mobile:",
      "phone_placeholder": "Phone number",
      "first_name_placeholder": "First name",
      "last_name_placeholder": "Last name",
      "email_placeholder": "Email address",
      "email_label": "Email:",
      "change_password": "Change password",
      "current_password": "Current Password:",
      "password_label": "New Password:",
      "password2_label": "Retype New Password:",
      "password_footnote": "Passwords must be at least 6 characters and contain at least 1 number or special character.",
      "cancel_change_password": "Don't change password",
      "units_label": "Units:",
      "units_metric": "Metric (°C, km)",
      "units_us": "Imperial (°F, mi)",
      "locale_label": "Language:",
      "equivalent_label": "Energy Equivalent:",
      "equivalent_display": "Start with",
      "notification_label": "Emails:",
      "preference_monthly_email": "Send me monthly system performance summaries",
      "preference_enphase_email": "Send me newsletters, promotions, and surveys regarding Enphase products or services",
      "production_issues_email": "Notify me about system production or service related issues",
      "save_successful": "Your information has been saved.",
      "save_successful_email": "Your information has been saved. See note below regarding your email change.",
      "save_failed": "Failed to save your information.",
      "system_info": "System Information for %{site_name}",
      "system_weather": "System Weather",
      "show_system_weather": "Show weather features for this site",
      "save": "Save"
    },
    "system_preferences": {
      "title": "System Preferences",
      "name_label": "Name:",
      "public_label": "Public System Page:",
      "public_text_html": "Create a public page for my system",
      "public_preview_link": "Preview public page",
      "public_help_link": "Learn more",
      "public_footnote": "This will enable social sharing features and allow visitors to your system.",
      "display_label": "Display system name as:",
      "save_changes": "Save System Preferences",
      "save_location_changes": "Save Privacy Settings",
      "save_successful": "Your system preferences have been saved.",
      "save_failed": "Failed to save system preferences."
    },
    "validations": {
      "required": "This field is required.",
      "password_too_short": "Your password must be at least six characters and contain at least one number or special character.",
      "password_too_long": "Please enter less than 50 characters.",
      "password_similar_to_username": "Your password can't be the same as your email address.",
      "password_too_weak": "Your password must be at least six characters and contain at least one number or special character.",
      "password_weak": "Your password must be at least six characters and contain at least one number or special character.",
      "password_good": "Password Strength: Good",
      "password_strong": "Password Strength: Strong",
      "password_policy": "Your password must be at least %{pwd_min_length}-%{pwd_max_length} characters and include %{digit_in_pwd} digit, %{uppercase_in_pwd} uppercase, %{lowercase_in_pwd} lowercase, %{special_character_in_pwd} number of special character and only (~!@#$%^&*)",
      "equalTo": "Please enter the same value again.",
      "invalid_phone_number": "Please enter a valid mobile number.",
      "empty_phone_number": "Please enter your mobile number.",
      "email_used": "Email ID is already registered. Retry with another email ID or $cHere to reset your password.",
      "emailInvalid": "Please enter a valid email address"
    }
  },
  "accountDelete": {
    "deleteAccount": "Delete Account",
    "deletePopUpText": "Your account and associated personal information would be deleted. You will be logged out after deleting the account. Do you want to proceed?",
    "deleteCnfText": "Your account and associated personal information would be deleted, except information we are required to maintain in connection with your Energy System. You will be logged out after deleting the account. Do you want to proceed?",
    "yes": "Yes",
    "no": "No",
    "verificationCode": "Verification Code",
    "enterCodeText": "Enter the 4 digit code that was sent to your registered email address and the mobile number.",
    "didntReceive": "Didn’t receive code?",
    "resend": "Resend",
    "deleteCnfTextEnlm": "Your account and associated personal information would be deleted, except information we are required to maintain in connection with your Energy System. You will also lose access to Enlighten Manager. You will be logged out after deleting the account. Do you want to proceed?",
    "deleteAdmin": "Your account cannot be deleted as you are an Enphase admin user",
    "verifyCode": "Verify Code",
    "logOutText": "You will be logged out after verifying the code.",
    "confirmText": "Your account is deactivated. We will retain personal information related to your Energy System to honor your warranty and support your system.",
    "ok": "Ok, Got it",
    "activateCnfText": "Your Enphase account is not active as you have deleted your account. Would you like to activate it again?",
    "activateText": "Email ID is registered with Enphase. However, it is not active as it was deleted.",
    "click": "Click ",
    "activateAgain": "here to activate it again",
    "activateAccount": "Activate account",
    "emailIDRegistered": "Email ID is registered with Enphase. However, it is not active as it was deleted. $cHere to activate.",
    "deleteAccountPopupText": "Deleting your account will deactivate your account and remove all personal information associated with your account. As you are associated with an Enphase Energy System, we are required to retain your personal information in order to support product warranty, system upgrades and support.",
    "learnMore": "Learn More",
    "accountdeletion": "Your account is in the process of deletion. This process may take up to 30 days, and you may create a new account after your prior account is deleted.",
    "incorrectEmailandPass": "The email and password you entered does not match our records. Please try again.",
    "accountdeletioninfo": "Your account is in the process of deletion. It may take upto 30 days.",
    "WOAccntdeletePopup": "Deleting your account will deactivate your account and remove all personal information associated with your account.",
    "accountdelReq": "Account deletion request",
    "verfcodedel": "Your verification code for deleting Enphase account",
    "accountActvReq": "Account activation request",
    "codedelAccount": "Verification code for deleting Enphase account",
    "codeDuration": "This code will only be valid for 15 minutes.",
    "userDelReq": "User has requested for account delete option in the Enphase app. Please find the user details below",
    "requestReceived": "We received your request to activate your Enphase account. To do so, click the link below within 7 days of receiving this email.",
    "activate": "Activate",
    "accActivate": "Activate your account",
    "optdelaccount": "Your verification code for deleting Enphase account is %{otp}. This code is valid for 15 minutes.",
    "emailCheckInstruction": "Please check your email for instructions to activate the account."
  },
  "phase": {
    "all": "Three-Phase View",
    "phaseL": "Phase L",
    "msgOffGrid": "Phase wise power consumption data is not available when your system is in off grid."
  },
  "vls": {
    "vlsHeading": "Battery shutdown level",
    "shutdownLevelLine1": "In an outage, your battery will shut down at",
    "shutdownLevelLine1-2": "charge to conserve energy. It restarts by using the conserved energy when the utility grid restores power or solar panels start producing energy.",
    "shutdownLevelLine2": "Choose a high value if you are experiencing bad weather that impacts solar production.",
    "vlsWarning": "Battery shutdown level cannot be more than battery reserve (%{soc}%)",
    "stormVlsWarning": "Storm alert is on for your system. Once storm alert ends, the battery reserve will be updated to %{soc}% as reserve cannot be lower than shutdown level",
    "batteryReserveWarning": "Battery reserve cannot be set lower than battery shutdown level (%{horizontal}%). Please decrease your battery shutdown level from #Advanced Settings# to decrease the battery reserve.",
    "editRequest": "You have an active request. Please wait for confirmation or cancel that request to proceed with the selection."
  },
  "defaultLocale": {
    "popContent1": "Choose App Language",
    "popContentBody1": "Would you like to continue with ",
    "popContentBody2": " as your app language?",
    "button1": "Ok, Continue",
    "button2": "Choose another language",
    "button3": "No, Change to ",
    "en": "English",
    "de": "German",
    "es": "Spanish",
    "fr": "French",
    "it": "Italian",
    "nl": "Dutch",
    "pl": "Polish",
    "pt": "Portuguese",
    "en-AU": "English (AU)"
  },
  "woSolarWStorage": {
    "noArraysTitle": "No Arrays!",
    "noArraysDesc": "You don’t have any solar panels installed",
    "noAccessConsumptionData": "You don’t have access to consumption data for this site."
  },
  "drEventsActive": "DR Event: Active",
  "pleaseGoTo": "Please go to ",
  "enlightenManager": "Enlighten Manager",
  "updateNP": " to update your notification preferences.",
  "loadControl": {
    "enabled": "Enabled",
    "disabled": "Disabled",
    "smartEnabled": "Smart Control Enabled",
    "smartDisabled": "Smart Control Disabled",
    "offGridBehaviour": "Off Grid Behavior",
    "modeDetails": "Smart Control Mode Details",
    "newModeDetails": "Load Control Mode Details",
    "basicMode": "Basic Mode",
    "cannotUse": "%{loadName} cannot be used​",
    "genOnUSe": "%{loadName} can be used when generator is on​",
    "genMode": "Generator Mode",
    "batteryMode": "Battery Mode",
    "batteryModePercent": "%{loadName} can be used when battery charge is %{lowerSoc}% or above.​",
    "batteryModeSoc": "If battery charge goes below %{lowerSoc}%, %{loadName} cannot be used till battery recharges to %{upperSoc}%.",
    "loadControlHeading": "Control power to your loads when Off Grid",
    "loadControlSubHeading": "All loads will be powered when On Grid​",
    "powered": "Powered",
    "notPowered": "Not Powered",
    "unknown": "Unknown",
    "permissionOfIntstaller": "You don't have permission to edit any settings for this load. Please contact your installer or Enphase customer support to know more about this.",
    "willbePowered": "Your %{loadName} will always be powered in this state.",
    "poweredOnOffGrid": "Your %{loadName} will be powered based on the selected Off Grid Behavior.",
    "continueModal": "Do you want to continue?",
    "infoDetails": "When smart control is disabled or when your system is On Grid, the loads will always be powered.",
    "newInfoDetails": "Control power to your loads based on energy resource or time of the day. You can also use Manual mode if you want to control power to your loads instantaneously.",
    "enableSmartComtrol": "Enable smart control to use this functionality.",
    "enableToggle": "Enable Smart Control?",
    "disableToggle": "Disable Smart Control?",
    "apply": "Apply",
    "modalPara1": "<div>When smart control is <span style='color: #F37320'>Enabled</span>, you can choose one of the three modes for Off Grid behavior.</div>",
    "disabledModalText": "Smart control feature is disabled for this load. Please enable the smart control feature using the toggle button to update the Off Grid behavior",
    "batteryChargeLowerLimit": "Battery charge lower limit cannot be below 10%",
    "batteryChargeHigherLimit": "Battery Charge lower limit cannot be above 90%",
    "loadControlLoadingToast": "%{loadName} status confirmation is taking longer than expected. Please check back later.",
    "loadControlTakingLonger": "Load status confirmation is taking longer than expected. Please check back later.",
    "batteryChargeLowerHigherLimit": "Battery charge lower limit and higher limit should have a minimum difference of 5%",
    "mode": "Mode",
    "lcMainHeading": "Control power to your loads",
    "basic": "Basic",
    "scheduled": "Scheduled",
    "advanced": "Advanced",
    "manual": "Manual",
    "notSelected": "Not Selected",
    "poweredWhen": "Powered when battery charge is above",
    "poweredGenOn": "Powered when generator is on",
    "poweredBetweenTime": "Powered between %{startTime} and %{endTime}",
    "onceDisconnected": "Once disconnected from the power source, load will not be powered unless the battery recharges to 100%.",
    "alwaysPowered": "Always Powered",
    "neverPowered": "Never Powered",
    "minDiff": "Start Time and End Time should have a minimum difference of 15 mins.",
    "startLessThanEnd": "Start Time should be less than End Time",
    "notValidTime": "Start Time and End Time should be within %{startTime} and %{endTime}.",
    "completed": "%{loadName} mode updated successfully.",
    "notCompleted": "Your request could not be completed. Please try again later",
    "completedAll": "Loads updated successfully.",
    "emptyLoadControls": "No load control found",
    "allowedWarning": "When modifying this time window, please ensure that your solar production is sufficient to support your consumption throughout this time window.",
    "advancedMode": {
      "subtitle": "Control the load using:",
      "notPowered": "Powered when charge is above ",
      "batterySocDesc1": "Not powered when charge drops below ",
      "batterySocDesc2": "Powered only after the battery recharges to ",
      "batterySocDesc3": " (even if generator is on)",
      "notAvailable": "Not available",
      "onGridGenPowered": "Powered Off Grid",
      "offGridGenPowered": "Powered when generator is on"
    }
  },
  "app_info": {
    "update_available": "App update available",
    "already_updatec": "Your app is up to date",
    "update_now": "Update Now",
    "latest_update": "Latest Update",
    "update_history": "Update History",
    "show_more": "Show more",
    "show_less": "Show less"
  },
  "s1": "Help me select a profile",
  "s2": "Learn about battery profiles",
  "s3": "Suggest a profile for me",
  "s4": "Battery charge is greater than reserve",
  "s5": "Energy Independence after peak hours:",
  "s6": "During off-peak hours your solar panels will charge your battery first before powering your home. Any excess solar power will be sent back to the grid to reduce your electric bill.",
  "s7": "If your home needs more power than your solar panels are producing, electricity will be used from the grid.",
  "s8": "System behavior during peak hours",
  "s9": "Reduce your electric bills",
  "s10": "In some areas, the cost of electricity shifts through the day, becoming more expensive during peak hours when electricity is in high demand.",
  "s11": "To avoid buying electricity at a higher cost, your home will use the battery. If your home needs more power than the battery can provide, solar is used next and the grid is used last. Any excess solar would be exported to the grid.",
  "s12": "At night when your solar panels aren’t producing anything, your home uses power from your battery until its reserve charge level is reached.",
  "s13": "Electricity gets imported from the grid when solar is not available and your home needs more power than battery can provide.",
  "s14": "Power your home with clean energy",
  "s15": "Your home will prioritize use of clean energy. During the day, solar powers the home and then the battery. Any excess is exported to the grid. During the night, battery powers the home.",
  "s16": "Electricity gets imported from the grid when your home needs more power than solar and battery can provide together.",
  "s17": "Battery is fully charged",
  "s18": "System behavior during off-peak hours",
  "s19": "Your panels will power your battery first and then your home. Any extra power will be sent to the grid.",
  "s20": "At night or any time you need more power than your panels are producing, your home will use electricity from the grid. Your battery is never used, except during a power outage.",
  "s21": "Tap a profile to jump to it's pages.",
  "s22": "Swipe left or right to read more.",
  "s23": "Your batteries will discharge even after peak hours.",
  "s24": "Electricity gets imported from the grid when solar is not available and your home needs more power than battery can provide.",
  "s25": "System behavior during off-peak hours",
  "s26": "Stay powered during outages ",
  "guestUser": "Guest",
  "systemOwner": {
    "savings": {
      "infoPopUpContent": "This is the estimated amount of monetary savings from your system based on the solar production. This is calculated based on the electricity rate details entered.",
      "noTeriffMsg": "Add electricity rate to know your savings",
      "noBillingCyclefMsg": "Add billing cycle to know your savings",
      "getStarted": "Get Started",
      "billingCycle": {
        "more": "more than this time last billing cycle",
        "less": "less than this time last billing cycle",
        "same": "About the same as this time last billing cycle"
      },
      "calendarMonth": {
        "more": "more than this time previous month",
        "less": "less than this time previous month",
        "same": "About the same as this time previous month"
      },
      "day": {
        "more": "more than this time previous day",
        "less": "less than this time previous day",
        "same": "About the same as this time previous day",
        "significantMore": "Significantly higher than previous day"
      },
      "week": {
        "more": "more than this time previous week",
        "less": "less than this time previous week",
        "same": "About the same as this time previous week"
      },
      "year": {
        "more": "more than this time previous year",
        "less": "less than this time previous year",
        "same": "About the same as this time previous year"
      },
      "editElectricity": "EDIT ELECTRICITY RATE",
      "viewSavingsBased": "View savings based on",
      "calendarMonthTitle": "Calendar Month",
      "calendarMonthDesc": "Time period from the 1st of the month to the last day the month",
      "noExportRate": "Add %{exportCTA} to view your total savings",
      "exportRate": "Export Rate"
    }
  },
  "offline": (_offline = {
    "unableToConnectLocally": "Unable to connect locally",
    "limitedAppFunctionality": "Limited App Functionality",
    "needHelpGatewayWifi": "Need help with configuring gateway Wi-Fi connectivity",
    "howToConnectGatewayNetwork": "How to connect to gateway network",
    "connectGatewayToWifi": "Connect gateway to Wi-Fi network",
    "connectLocally": "CONNECT LOCALLY",
    "checkNetworkConnection": "Please check your network connection.",
    "noInternetModalSubText1": "Please check your network connection. In the meantime, you can view the current status of the system.",
    "noInternetModalSubText2": "Please check your network connection. In the meantime, if you are in the proximity of your system, you can connect locally with gateway to view current status.",
    "refereshing": "Refreshing",
    "pullToReferesh": "Pull to refresh",
    "connectionStatus": "Your phone is now connected locally to the gateway network.",
    "connectivityErrorMsg1": "Please make sure your phone and gateway are on the same network",
    "connectivityErrorMsg2": 'Gateway was recently connected to %{wifiName} network',
    "connectivityErrorMsg3": "Alternatively, connect your phone to gateway’s Wi-Fi by enabling AP mode on your gateway",
    "connecting": "Your phone is trying to connect locally with gateway to view Live Status.",
    "viewLiveStatus": "View Live Status",
    "pleaseTryAgainInSomeTime": "Please try again in sometime.",
    "connectedLocally": "Connected Locally",
    "ssidNotMatchedError": "You have not connected your cell phone to the correct gateway network. Please connect your cell phone to this gateway network: %{envoySSID}",
    "envoySSIDListDialog": {
      "title": "Gateway networks for this site",
      "message": "Please connect your cell phone only to the network of one of the gateways of this site. Following are the gateway networks for this site:",
      "buttonText": "Okay, got it!"
    },
    "multiEnvoySiteSSIDNotMatchedMsg": "You have not connected your cell phone to the correct gateway network. Please connect your cell phone only to the network of one of the gateways of this site.",
    "configureButtonMultiEnvoyMsg": "You have not connected your cell phone to the correct gateway network. Please connect your cell phone only to the network of one of the gateways of this site. Following are the gateway networks for this site:",
    "listOfGatewayNetworks": "List of gateway networks for this site",
    "configureWifiMultiEnvoyMsg": "To configure Wi-Fi for gateway (Serial No: XXXX) connect your mobile to AP mode of this gateway. You are currently connected to the AP mode of the gateway(Serial No:XX_%{sNumber}).",
    "deviceOfflineModal": {
      "title": "How to connect to gateway’s Wi-Fi",
      "okGotIt": "Ok, Got it",
      "subText": "Please make sure your phone and the gateway are on the same Wi-Fi network to connect locally",
      "gatewayNetwork": "(The gateway was last connected to '%{recentlyConnectedWifiMsg}')",
      "subText1": "Connect to gateway network locally if you want to change your system settings.",
      "subText2": 'Make sure your phone and gateway are on the same network %{recentlyConnectedWifiMsg}.',
      "wifiSSIDMsg": "(The gateway was recently connected to '%{lastConnection}' network)",
      "subText3": "Alternatively, connect your cell phone to gateway's Wi-Fi by enabling AP mode on your gateway",
      "connectToAPGateway": "Connect your phone to gateway's Wi-Fi by enabling AP mode on your gateway."
    },
    "systemStatus": {
      "recentWifiTitle": "Recent Wi-Fi connections of gateways",
      "gatewayPrefix": "Gateway S.N.",
      "gatewayBtn": "Gateway Wi-Fi networks for this site",
      "alternetively": "Alternatively, connect your phone to any one of the gateway’s network by enabling AP mode on your gateway."
    },
    "isTouPopupMsg": "Savings mode can not be activated as it works only if you have Net Energy Metering (NEM) and your electricity rate varies with Time-of-Use (ToU). Setting or updating the electricity rate is possible only when your phone is connected to the internet.",
    "configWifiToGateway": "Configure wi-fi for your gateway",
    "phoneNtConnectedToGateway": "Your phone is not connected to gateway",
    "chooseWifiNetwork": "Choose a Wi-Fi network you’d like to use with your gateway.",
    "learnWifiConfigToGatway": "Learn how to configure Wi-Fi for your gateway",
    "step": "Step",
    "connectPhoneToGateway": "Connect your phone to gateway",
    "connectToGatewayNetwork": "Connect to gateway’s network to configure Wi-Fi for your gateway",
    "gatewayNtReachable": "Your gateway is not reachable",
    "pleaseEnsure": "Please ensure:",
    "gatewayAPModeOn": "Gateway’s AP mode is turned on",
    "phoneInCloseProximity": "Phone is in close proximity to the gateway",
    "mobileDataOff": "Mobile data (cellular data) is turned off",
    "searchingGateway": "Searching for gateway network…",
    "devicePluggedIn": "Make sure your device is near by, plugged in and AP mode is on",
    "connectingTo": "Connecting to",
    "reflectedInApp": "This might take a couple of minutes to be reflected in app",
    "connectionFailed": "Failed to connect to gateway’s network",
    "connectedToGateway": "Phone is connected to gateway"
  }, _defineProperty(_offline, "connectGatewayToWifi", "Connect Gateway to Wi-Fi"), _defineProperty(_offline, "chooseNetworkToConnectGateway", "Choose a Wi-Fi network you’d like to connect your gateway to."), _defineProperty(_offline, "scanNetwork", "Scan Wi-Fi Network"), _defineProperty(_offline, "enterPassword", "Enter the password for"), _defineProperty(_offline, "join", "Join"), _defineProperty(_offline, "gatewayConnected", "Gateway is connected to %{selectedWifi} successfully"), _defineProperty(_offline, "disconnectPhoneFromGateway", "You may now disconnect your phone from your gateway network and connect it to your Wi-Fi/enable your mobile data"), _defineProperty(_offline, "failedToConnect", "Failed to Connect"), _defineProperty(_offline, "gatewayConnectedToPoerSource", "Please make sure that your gateway is connected to a power source, and you are in close proximity to your gateway."), _defineProperty(_offline, "routerIsOn", "Make sure your Wi-Fi router is on, and you are in close proximity to your Wi-Fi router"), _defineProperty(_offline, "unableToDisplayNetworks", "Unable to display Wi-Fi networks"), _defineProperty(_offline, "errorDisplayingNetworks", "An error occurred in displaying Wi-FI networks due to some technical issues. Please try again."), _defineProperty(_offline, "errorInConnectingToWifi", "An error occurred while connecting to the WiFi network. Please try later or connect to a different network."), _defineProperty(_offline, "unableToConnect", "Unable to Connect"), _defineProperty(_offline, "pairGateway", "Pair the gateway with your phone via bluetooth."), _offline),
  "tutorial": {
    "back": "Back",
    "apMode": "How to turn on AP mode",
    "step1": "step 1 of 3",
    "step2": "step 2 of 3",
    "step3": "step 3 of 3",
    "powerOnGateway": "Power on gateway",
    "title2": "Press AP mode button",
    "brieflyPressGateway": "Briefly press and release (do not hold) the gateway menu button next the phone icon",
    "getStarted": "Get started",
    "next": "Next step",
    "prev": "Previous Step",
    "via": "Via",
    "chooseWifi": "After connecting your phone to the gateway, choose the Wi-Fi you want to connect your gateway to",
    "connectGateway": "Connect to gateway's network to configue Wi-Fi  for your gateway",
    "selectGateway": "Select your gateway type",
    "thatsIt": "That's it",
    "step1of2": "Step 1 of 2",
    "step2of2": "Step 2 of 2",
    "learnHow": "Learn how",
    "tryConnectingGateway": "Let's try connecting gateway to your phone. Please make sure  the you are in close proximity  to your gateway and your mobile cellular data is turned off."
  }
};
module.exports = mobile;